(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class GudslipAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
      if (this.slides.length === 0) return;

      this.indice = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.indice < 0) {
        this.indice = 0;
        this.slides[0].classList.add('is-active');
      }

      const segundos = parseFloat(this.dataset.velocidad);
      this.intervalo = (isNaN(segundos) || segundos <= 0 ? 4 : segundos) * 1000;
      this.autoplay = this.dataset.autoplay !== 'false' && this.slides.length > 1;
      this.movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.alEntrar = () => this.parar();
      this.alSalir = () => this.iniciar();
      this.alCambiarVisibilidad = () => (document.hidden ? this.parar() : this.iniciar());

      this.addEventListener('mouseenter', this.alEntrar);
      this.addEventListener('mouseleave', this.alSalir);
      this.addEventListener('focusin', this.alEntrar);
      this.addEventListener('focusout', this.alSalir);
      document.addEventListener('visibilitychange', this.alCambiarVisibilidad);

      this.iniciar();
    }

    disconnectedCallback() {
      this.parar();
      document.removeEventListener('visibilitychange', this.alCambiarVisibilidad);
    }

    iniciar() {
      if (!this.autoplay || this.movimientoReducido || document.hidden) return;
      this.parar();
      this.temporizador = setInterval(() => this.siguiente(), this.intervalo);
    }

    parar() {
      if (this.temporizador) {
        clearInterval(this.temporizador);
        this.temporizador = null;
      }
    }

    siguiente() {
      this.slides[this.indice].classList.remove('is-active');
      this.indice = (this.indice + 1) % this.slides.length;
      this.slides[this.indice].classList.add('is-active');
    }
  }

  if (!customElements.get('gudslip-announcement-bar')) {
    customElements.define('gudslip-announcement-bar', GudslipAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-principal"] && !Shopify.designMode) return;
  try {
    
  const BRILLO_MARGEN = 24;
  const BRILLO_VUELTA = Math.PI * 2;

  const BRILLO_VERTICE = `#version 300 es
in vec2 aPosition;
void main() {
  gl_Position = vec4(aPosition, 0.0, 1.0);
}`;

  const BRILLO_FRAGMENTO = `#version 300 es
precision highp float;
uniform vec2 uCenter;
uniform vec2 uHalf;
uniform float uRadius;
uniform float uPx;
uniform float uSpot;
uniform vec2 uEntry;
uniform vec3 uLineColor;
uniform vec3 uBaseColor;
uniform float uIntensity;
uniform vec2 uWindow;
uniform float uThickness;
uniform float uGlow;
out vec4 outColor;

float roundedBox(vec2 p, vec2 b, float r) {
  vec2 q = abs(p) - b + r;
  return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r;
}

float loopPosition(vec2 p, vec2 b, float r) {
  vec2 inner = b - r;
  float arc = 1.5707963 * r;
  float quarter = inner.x + inner.y + arc;
  vec2 a = abs(p);
  vec2 q = a - inner;
  float s = q.x > 0.0 && q.y > 0.0
    ? inner.y + atan(q.y, q.x) * r
    : (q.x > q.y ? min(a.y, inner.y) : inner.y + arc + inner.x - min(a.x, inner.x));
  if (p.x < 0.0) s = p.y >= 0.0 ? 2.0 * quarter - s : 2.0 * quarter + s;
  else if (p.y < 0.0) s = 4.0 * quarter - s;
  return s / max(4.0 * quarter, 0.0001);
}

float lobe(float position, float center) {
  float gap = abs(fract(position - center + 0.5) - 0.5);
  return 1.0 - smoothstep(uWindow.x, uWindow.x + uWindow.y, gap);
}

void main() {
  vec2 p = gl_FragCoord.xy - uCenter;
  float d = roundedBox(p, uHalf, uRadius);
  float position = loopPosition(p, uHalf, uRadius);
  float key = lobe(position, uSpot);
  float back = lobe(position, uSpot + 0.5);
  float streak = key + back * 0.45;
  float width = max(uThickness * uPx * mix(1.0, max(key, back), 0.6), 0.35);
  float band = smoothstep(-width - 0.6, -width + 0.6, d) * (1.0 - smoothstep(-0.6, 0.6, d));
  float hair = smoothstep(-uPx - 0.6, -uPx + 0.6, d) * (1.0 - smoothstep(-0.6, 0.6, d));
  float inside = 1.0 - smoothstep(-0.6, 0.6, d);
  vec2 pool = (p - uEntry) / (uHalf.y * vec2(1.6, 1.1));
  float glow = streak * 0.2 * exp(-abs(d + width * 0.5) / (5.0 * uPx)) + inside * 0.08 * exp(-dot(pool, pool));
  float light = clamp((band * streak + glow * uGlow) * uIntensity, 0.0, 1.0);
  vec4 base = vec4(uBaseColor, 1.0) * hair * 0.6;
  outColor = vec4(uLineColor, 1.0) * light + base * (1.0 - light);
}`;

  const BRILLO_UNIFORMES = ['uCenter', 'uHalf', 'uRadius', 'uPx', 'uSpot', 'uEntry', 'uLineColor', 'uBaseColor', 'uIntensity', 'uWindow', 'uThickness', 'uGlow'];

  const brilloLimitar = (valor, min, max) => Math.min(max, Math.max(min, valor));
  const brilloEnvolver = (valor) => valor - Math.floor(valor);

  const brilloPosicionBorde = (x, y, mitadX, mitadY, r) => {
    const dentroX = mitadX - r;
    const dentroY = mitadY - r;
    const arco = (Math.PI / 2) * r;
    const cuarto = dentroX + dentroY + arco;
    const ax = Math.abs(x);
    const ay = Math.abs(y);
    const qx = ax - dentroX;
    const qy = ay - dentroY;
    let s;
    if (qx > 0 && qy > 0) s = dentroY + Math.atan2(qy, qx) * r;
    else if (qx > qy) s = Math.min(ay, dentroY);
    else s = dentroY + arco + dentroX - Math.min(ax, dentroX);
    if (x < 0) s = y >= 0 ? 2 * cuarto - s : 2 * cuarto + s;
    else if (y < 0) s = 4 * cuarto - s;
    return brilloEnvolver(s / Math.max(4 * cuarto, 0.0001));
  };

  const brilloPuntoBorde = (posicion, mitadX, mitadY, r) => {
    const dentroX = mitadX - r;
    const dentroY = mitadY - r;
    const arco = (Math.PI / 2) * r;
    const cuarto = dentroX + dentroY + arco;
    let s = brilloEnvolver(posicion) * 4 * cuarto;
    let signoX = 1;
    let signoY = 1;
    if (s > 3 * cuarto) {
      s = 4 * cuarto - s;
      signoY = -1;
    } else if (s > 2 * cuarto) {
      s -= 2 * cuarto;
      signoX = -1;
      signoY = -1;
    } else if (s > cuarto) {
      s = 2 * cuarto - s;
      signoX = -1;
    }
    let x = dentroX - (s - dentroY - arco);
    let y = mitadY;
    if (s <= dentroY) {
      x = mitadX;
      y = s;
    } else if (s <= dentroY + arco) {
      const angulo = (s - dentroY) / Math.max(r, 0.0001);
      x = dentroX + Math.cos(angulo) * r;
      y = dentroY + Math.sin(angulo) * r;
    }
    return [x * signoX, y * signoY];
  };

  class BannerPrincipalBrillo {
    constructor(boton, ajustes) {
      this.boton = boton;
      this.s = ajustes;
      this.lienzo = document.createElement('canvas');
      this.lienzo.className = 'banner-principal__brillo';
      this.lienzo.setAttribute('aria-hidden', 'true');
      const gl = this.lienzo.getContext('webgl2', {
        alpha: true,
        premultipliedAlpha: true,
        antialias: false,
        depth: false,
        stencil: false
      });
      if (!gl) throw new Error('WebGL2 no disponible');
      this.gl = gl;
      this.programa = this.enlazar();
      if (!this.programa) {
        gl.getExtension('WEBGL_lose_context')?.loseContext();
        throw new Error('No se pudo compilar el brillo');
      }
      this.u = {};
      BRILLO_UNIFORMES.forEach((nombre) => {
        this.u[nombre] = gl.getUniformLocation(this.programa, nombre);
      });
      this.bufer = gl.createBuffer();
      this.vao = gl.createVertexArray();
      gl.bindVertexArray(this.vao);
      gl.bindBuffer(gl.ARRAY_BUFFER, this.bufer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      gl.enableVertexAttribArray(0);
      gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
      gl.bindVertexArray(null);

      this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches && !ajustes.ignorarReducido;
      this.vista = { ancho: 1, alto: 1, ratio: 1 };
      this.puntero = { x: 0, y: 0, conocido: false };
      this.estado = { spot: 0, nivel: 0, pulsar: 0, listo: false };
      this.raf = 0;
      this.ultimo = 0;
      this.visible = true;

      this.boton.prepend(this.lienzo);

      this.alMover = (evento) => {
        this.puntero.x = evento.clientX;
        this.puntero.y = evento.clientY;
        this.puntero.conocido = true;
        this.despertar();
      };
      this.alPulsar = (evento) => {
        this.puntero.x = evento.clientX;
        this.puntero.y = evento.clientY;
        this.puntero.conocido = true;
        this.estado.pulsar = 1;
        this.despertar();
      };
      this.alSoltar = (evento) => {
        if (evento.pointerType === 'mouse') return;
        this.puntero.conocido = false;
        this.despertar();
      };
      this.alSalir = () => {
        this.puntero.conocido = false;
        this.despertar();
      };
      this.alPerderContexto = (evento) => {
        evento.preventDefault();
        this.destruir();
      };

      this.observadorTamano = new ResizeObserver((entradas) => this.medir(entradas[entradas.length - 1]));
      this.observadorTamano.observe(this.boton);
      this.observadorVista = new IntersectionObserver((entradas) => {
        this.visible = entradas.some((entrada) => entrada.isIntersecting);
        if (this.visible) {
          this.ultimo = 0;
          this.despertar();
        }
      });
      this.observadorVista.observe(this.boton);
      window.addEventListener('pointermove', this.alMover, { passive: true });
      window.addEventListener('pointerup', this.alSoltar, { passive: true });
      window.addEventListener('pointercancel', this.alSoltar, { passive: true });
      document.documentElement.addEventListener('pointerleave', this.alSalir);
      this.boton.addEventListener('pointerdown', this.alPulsar);
      this.lienzo.addEventListener('webglcontextlost', this.alPerderContexto);
      this.medir();
    }

    enlazar() {
      const gl = this.gl;
      const compilar = (tipo, fuente) => {
        const shader = gl.createShader(tipo);
        if (!shader) return null;
        gl.shaderSource(shader, fuente);
        gl.compileShader(shader);
        if (gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return shader;
        gl.deleteShader(shader);
        return null;
      };
      const vertice = compilar(gl.VERTEX_SHADER, BRILLO_VERTICE);
      const fragmento = compilar(gl.FRAGMENT_SHADER, BRILLO_FRAGMENTO);
      const programa = gl.createProgram();
      if (!vertice || !fragmento || !programa) return null;
      gl.attachShader(programa, vertice);
      gl.attachShader(programa, fragmento);
      gl.bindAttribLocation(programa, 0, 'aPosition');
      gl.linkProgram(programa);
      gl.deleteShader(vertice);
      gl.deleteShader(fragmento);
      if (gl.getProgramParameter(programa, gl.LINK_STATUS)) return programa;
      gl.deleteProgram(programa);
      return null;
    }

    radioEsquina() {
      return Math.min(this.s.radio, this.vista.ancho / 2, this.vista.alto / 2);
    }

    spotReposo() {
      const r = this.radioEsquina();
      const hueco = r * (1 - Math.SQRT1_2);
      return brilloPosicionBorde(hueco - this.vista.ancho / 2, this.vista.alto / 2 - hueco, this.vista.ancho / 2, this.vista.alto / 2, r);
    }

    apuntar() {
      if (!this.s.seguirRaton || !this.puntero.conocido) return null;
      const rect = this.boton.getBoundingClientRect();
      const escala = rect.width / this.vista.ancho || 1;
      const mitadX = this.vista.ancho / 2;
      const mitadY = this.vista.alto / 2;
      const x = (this.puntero.x - rect.left - rect.width / 2) / escala;
      const y = (rect.top + rect.height / 2 - this.puntero.y) / escala;
      const distancia = Math.hypot(Math.max(Math.abs(x) - mitadX, 0), Math.max(Math.abs(y) - mitadY, 0));
      const t = brilloLimitar(1 - distancia / this.s.proximidad, 0, 1);
      const cerca = t * t * (3 - 2 * t);
      const masCercano = brilloPosicionBorde(x, y, mitadX, mitadY, this.radioEsquina());
      if (distancia > 0) return { spot: masCercano, cerca };
      const profundidad = brilloLimitar(Math.min(mitadX - Math.abs(x), mitadY - Math.abs(y)) / (mitadY * 0.8), 0, 1);
      const vaiven = this.spotReposo() - (x / mitadX) * 0.06 - (y / mitadY) * 0.02;
      const desfase = vaiven - masCercano - Math.round(vaiven - masCercano);
      return { spot: brilloEnvolver(masCercano + desfase * profundidad * profundidad * (3 - 2 * profundidad)), cerca };
    }

    dibujar() {
      const gl = this.gl;
      const s = this.s;
      const { ancho, alto } = this.vista;
      const escalaX = this.lienzo.width / (ancho + BRILLO_MARGEN * 2);
      const escalaY = this.lienzo.height / (alto + BRILLO_MARGEN * 2);
      gl.viewport(0, 0, this.lienzo.width, this.lienzo.height);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.useProgram(this.programa);
      gl.uniform2f(this.u.uCenter, (BRILLO_MARGEN + ancho / 2) * escalaX, (BRILLO_MARGEN + alto / 2) * escalaY);
      gl.uniform2f(this.u.uHalf, (ancho / 2) * escalaX, (alto / 2) * escalaY);
      gl.uniform1f(this.u.uRadius, Math.min(s.radio, ancho / 2, alto / 2) * escalaX);
      gl.uniform1f(this.u.uPx, this.vista.ratio);
      const r = Math.min(s.radio, ancho / 2, alto / 2);
      const [bordeX, bordeY] = brilloPuntoBorde(this.estado.spot, ancho / 2, alto / 2, r);
      const tirar = 1 - Math.min(0.35 * (alto / 2), Math.hypot(bordeX, bordeY)) / Math.max(Math.hypot(bordeX, bordeY), 0.0001);
      gl.uniform1f(this.u.uSpot, this.estado.spot);
      gl.uniform2f(this.u.uEntry, bordeX * tirar * escalaX, bordeY * tirar * escalaY);
      gl.uniform3fv(this.u.uLineColor, s.colorLinea);
      gl.uniform3fv(this.u.uBaseColor, s.colorBase);
      gl.uniform1f(this.u.uIntensity, s.intensidad * (this.estado.nivel + this.estado.pulsar * 0.8));
      gl.uniform2f(this.u.uWindow, s.tamano / 360 + this.estado.pulsar * 0.06, s.difuminado / 360 + 0.0001);
      gl.uniform1f(this.u.uThickness, s.grosor);
      gl.uniform1f(this.u.uGlow, s.resplandor);
      gl.bindVertexArray(this.vao);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      gl.bindVertexArray(null);
    }

    fotograma(ahora) {
      this.raf = 0;
      if (!this.visible || !this.gl) return;
      const s = this.s;
      const dt = this.ultimo ? Math.min(0.05, (ahora - this.ultimo) / 1000) : 1 / 60;
      this.ultimo = ahora;
      const objetivo = this.apuntar();
      const girando = s.giroAutomatico && !this.reducido;
      const guiando = !!objetivo && objetivo.cerca > 0;
      if (!this.estado.listo) {
        this.estado.spot = this.spotReposo();
        this.estado.nivel = s.giroAutomatico ? 1 : s.reposo;
        this.estado.listo = true;
      }
      let diferencia = 0;
      if (girando && !guiando) {
        this.estado.spot = brilloEnvolver(this.estado.spot + (s.velocidad / BRILLO_VUELTA) * dt);
      } else {
        diferencia = (guiando ? objetivo.spot : this.spotReposo()) - this.estado.spot;
        diferencia -= Math.round(diferencia);
        this.estado.spot = brilloEnvolver(this.estado.spot + diferencia * (1 - Math.exp(-dt * 8)));
      }
      const nivel = s.giroAutomatico ? 1 : s.reposo + (1 - s.reposo) * (objetivo ? objetivo.cerca : 0);
      this.estado.nivel += (nivel - this.estado.nivel) * (1 - Math.exp(-dt * 7));
      this.estado.pulsar *= Math.exp(-dt * 5);
      this.dibujar();
      const asentando = Math.abs(diferencia) > 0.0002 || Math.abs(nivel - this.estado.nivel) > 0.001 || this.estado.pulsar > 0.002;
      if (asentando || (girando && !guiando)) this.raf = requestAnimationFrame((t) => this.fotograma(t));
      else this.ultimo = 0;
    }

    despertar() {
      if (!this.raf && this.visible && this.gl) this.raf = requestAnimationFrame((t) => this.fotograma(t));
    }

    medir() {
      this.vista.ancho = Math.max(1, this.boton.offsetWidth);
      this.vista.alto = Math.max(1, this.boton.offsetHeight);
      this.vista.ratio = Math.min(window.devicePixelRatio || 1, 3);
      this.lienzo.width = Math.max(1, Math.round((this.vista.ancho + BRILLO_MARGEN * 2) * this.vista.ratio));
      this.lienzo.height = Math.max(1, Math.round((this.vista.alto + BRILLO_MARGEN * 2) * this.vista.ratio));
      if (this.estado.listo) this.dibujar();
      this.despertar();
    }

    destruir() {
      if (!this.gl) return;
      const gl = this.gl;
      this.gl = null;
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.observadorTamano.disconnect();
      this.observadorVista.disconnect();
      window.removeEventListener('pointermove', this.alMover);
      window.removeEventListener('pointerup', this.alSoltar);
      window.removeEventListener('pointercancel', this.alSoltar);
      document.documentElement.removeEventListener('pointerleave', this.alSalir);
      this.boton.removeEventListener('pointerdown', this.alPulsar);
      this.lienzo.removeEventListener('webglcontextlost', this.alPerderContexto);
      gl.deleteBuffer(this.bufer);
      gl.deleteVertexArray(this.vao);
      gl.deleteProgram(this.programa);
      gl.getExtension('WEBGL_lose_context')?.loseContext();
      if (this.lienzo.parentNode) this.lienzo.parentNode.removeChild(this.lienzo);
      this.boton.removeAttribute('data-brillo-activo');
    }
  }

  const PLEGADO_BISAGRAS = {
    top: { origen: '50% 0%', eje: 'rotateX', signo: -1 },
    bottom: { origen: '50% 100%', eje: 'rotateX', signo: 1 },
    left: { origen: '0% 50%', eje: 'rotateY', signo: 1 },
    right: { origen: '100% 50%', eje: 'rotateY', signo: -1 }
  };

  const PLEGADO_LAMAS = {
    rotateX: {
      origenes: ['50% 25%', '50% 75%'],
      recortes: ['inset(-40% -20% 50% -20%)', 'inset(50% -20% -40% -20%)']
    },
    rotateY: {
      origenes: ['25% 50%', '75% 50%'],
      recortes: ['inset(-40% 50% -40% -20%)', 'inset(-40% -20% -40% 50%)']
    }
  };

  const PLEGADO_CURVAS = {
    suave: (x) => 1 - Math.pow(1 - x, 2),
    marcado: (x) => 1 - Math.pow(1 - x, 3),
    intenso: (x) => 1 - Math.pow(1 - x, 4),
    rebote: (x) => {
      const c1 = 1.70158;
      const c3 = c1 + 1;
      return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
    }
  };

  const PLEGADO_RETARDO_LAMA = 0.24;
  const plegadoLimitar = (valor, min, max) => Math.min(max, Math.max(min, valor));

  class BannerPrincipalPlegado {
    constructor(elemento, opciones) {
      this.el = elemento;
      this.estilo = ['paper', 'blinds', 'flip'].includes(opciones.estilo) ? opciones.estilo : 'paper';
      this.nombreBisagra = PLEGADO_BISAGRAS[opciones.bisagra] ? opciones.bisagra : 'top';
      const bisagra = PLEGADO_BISAGRAS[this.nombreBisagra];
      this.eje = bisagra.eje;
      this.signo = bisagra.signo;
      this.origen = bisagra.origen;
      this.lamas = PLEGADO_LAMAS[this.eje];
      const reducido = !!opciones.reducido;
      this.angulo = reducido ? 0 : this.estilo === 'flip' ? 180 : plegadoLimitar(opciones.angulo, 0, 180);
      this.pliegue = reducido ? 0 : plegadoLimitar(opciones.sombra, 0, 1);
      this.inclinacionRaton =
        opciones.reaccionar && !reducido && window.matchMedia('(hover: hover)').matches
          ? plegadoLimitar(opciones.anguloRaton, 0, 180)
          : 0;
      this.radio = Math.max(1, opciones.radio || 140);
      this.elevacion = this.estilo === 'flip' && !reducido ? 0.45 : 0;
      this.duracion = Math.max(1, reducido ? Math.min(opciones.duracion, 220) : opciones.duracion);
      this.escalon = Math.max(0, reducido ? Math.min(opciones.escalon, 20) : opciones.escalon);
      this.desde = opciones.desde || 'start';
      this.abrir = reducido ? (x) => x : PLEGADO_CURVAS[opciones.curva] || PLEGADO_CURVAS.marcado;
      this.cerrar = reducido ? (x) => x : (x) => x * x;
      this.porPalabra = opciones.por === 'word';

      this.dividir();

      this.piezas = Array.from(this.el.querySelectorAll('.banner-principal__plegado-pieza')).map((pieza) => {
        const partes = this.estilo === 'blinds' ? Array.from(pieza.children) : [pieza];
        if (this.estilo === 'blinds') {
          pieza.style.opacity = '1';
          partes.forEach((parte, i) => {
            parte.style.transformOrigin = this.lamas.origenes[i];
            if (i > 0) parte.style.clipPath = this.lamas.recortes[i];
          });
        } else {
          pieza.style.transformOrigin = this.estilo === 'flip' ? '50% 50%' : this.origen;
          pieza.style.backfaceVisibility = this.estilo === 'flip' ? 'visible' : 'hidden';
        }
        return { pieza, partes, t: 0, f: 0, r: 0, objetivo: 0, inicio: 0 };
      });

      this.raf = 0;
      this.rafRaton = 0;
      this.puntero = null;
      this.centros = null;
      this.medida = null;
      this.renderizar();

      if (this.inclinacionRaton > 0 && this.piezas.length) {
        this.alMover = (evento) => {
          this.puntero = { x: evento.clientX, y: evento.clientY };
          this.apuntar();
        };
        this.alSalir = () => {
          this.puntero = null;
          this.apuntar();
        };
        this.alDesplazar = () => {
          if (this.puntero) this.apuntar();
        };
        window.addEventListener('pointermove', this.alMover, { passive: true });
        window.addEventListener('scroll', this.alDesplazar, { passive: true, capture: true });
        document.documentElement.addEventListener('pointerleave', this.alSalir);
      }
    }

    dividir() {
      const texto = (this.el.textContent || '').replace(/\s+/g, ' ').trim();
      const visual = document.createElement('span');
      visual.className = 'banner-principal__plegado-visual';
      visual.setAttribute('aria-hidden', 'true');
      while (this.el.firstChild) visual.appendChild(this.el.firstChild);
      this.recorrer(visual);
      const oculto = document.createElement('span');
      oculto.className = 'banner-principal__plegado-oculto';
      oculto.textContent = texto;
      this.el.appendChild(oculto);
      this.el.appendChild(visual);
    }

    recorrer(nodo) {
      Array.from(nodo.childNodes).forEach((hijo) => {
        if (hijo.nodeType === 3) {
          hijo.replaceWith(this.trocear(hijo.nodeValue));
        } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR' && hijo.tagName !== 'svg') {
          this.recorrer(hijo);
        }
      });
    }

    trocear(texto) {
      const fragmento = document.createDocumentFragment();
      texto.split(/(\s+)/).forEach((parte) => {
        if (!parte) return;
        if (/^\s+$/.test(parte)) {
          fragmento.appendChild(document.createTextNode(parte));
          return;
        }
        if (this.porPalabra) {
          fragmento.appendChild(this.segmento(parte));
          return;
        }
        const palabra = document.createElement('span');
        palabra.className = 'banner-principal__plegado-palabra';
        Array.from(parte).forEach((letra) => palabra.appendChild(this.segmento(letra)));
        fragmento.appendChild(palabra);
      });
      return fragmento;
    }

    segmento(contenido) {
      const segmento = document.createElement('span');
      segmento.className = 'banner-principal__plegado-segmento';
      const pieza = document.createElement('span');
      pieza.className = 'banner-principal__plegado-pieza';
      pieza.dataset.bisagra = this.nombreBisagra;
      if (this.estilo === 'blinds') {
        pieza.dataset.estilo = 'blinds';
        ['a', 'b'].forEach((lado) => {
          const lama = document.createElement('span');
          lama.className = 'banner-principal__plegado-lama';
          lama.dataset.lama = lado;
          lama.dataset.pliegue = contenido;
          lama.textContent = contenido;
          pieza.appendChild(lama);
        });
      } else {
        pieza.dataset.pliegue = contenido;
        pieza.textContent = contenido;
        pieza.style.opacity = '0';
      }
      segmento.appendChild(pieza);
      return segmento;
    }

    sombra(progreso, inclinacion) {
      return String(this.pliegue * plegadoLimitar(1 - progreso + inclinacion / 90, 0, 1));
    }

    renderizar() {
      this.piezas.forEach((p) => {
        const inclinacion = p.r * this.inclinacionRaton;
        if (this.estilo === 'blinds') {
          let quieta = inclinacion < 0.05;
          p.partes.forEach((parte, i) => {
            const desfase = i * PLEGADO_RETARDO_LAMA;
            const abierto = this.abrir(plegadoLimitar((p.t - desfase) / (1 - PLEGADO_RETARDO_LAMA), 0, 1));
            const cerrado = this.cerrar(plegadoLimitar((p.f - desfase) / (1 - PLEGADO_RETARDO_LAMA), 0, 1));
            const progreso = abierto * (1 - cerrado);
            if (Math.abs(1 - progreso) > 0.002) quieta = false;
            parte.style.transform = this.eje + '(' + this.signo * ((1 - progreso) * this.angulo + inclinacion) + 'deg)';
            parte.style.opacity = String(plegadoLimitar(progreso, 0, 1));
            parte.style.setProperty('--banner-pliegue', this.sombra(progreso, inclinacion));
          });
          p.partes[0].style.clipPath = quieta ? 'none' : this.lamas.recortes[0];
          p.partes[1].style.visibility = quieta ? 'hidden' : 'visible';
          return;
        }
        const progreso = this.abrir(p.t) * (1 - this.cerrar(p.f));
        const subida = this.elevacion * Math.sin(Math.PI * plegadoLimitar(progreso, 0, 1));
        const giro = this.eje + '(' + this.signo * ((1 - progreso) * this.angulo + inclinacion) + 'deg)';
        p.pieza.style.transform = subida > 0.001 ? 'translateZ(' + subida + 'em) ' + giro : giro;
        p.pieza.style.opacity = String(plegadoLimitar(progreso, 0, 1));
        p.pieza.style.setProperty('--banner-pliegue', this.sombra(progreso, inclinacion));
      });
    }

    ordenes() {
      const n = this.piezas.length;
      const mitad = (n - 1) / 2;
      if (this.desde === 'random') {
        const orden = this.piezas.map((_, i) => i);
        for (let i = orden.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [orden[i], orden[j]] = [orden[j], orden[i]];
        }
        return orden;
      }
      return this.piezas.map((_, i) => {
        if (this.desde === 'end') return n - 1 - i;
        if (this.desde === 'center') return Math.abs(i - mitad);
        if (this.desde === 'edges') return mitad - Math.abs(i - mitad);
        return i;
      });
    }

    reproducir(retardo) {
      if (!this.piezas.length) return;
      cancelAnimationFrame(this.raf);
      const ahora = performance.now();
      const ordenes = this.ordenes();
      this.piezas.forEach((p, i) => {
        p.t = 0;
        p.f = 0;
        p.inicio = ahora + (retardo || 0) + ordenes[i] * this.escalon;
      });
      this.renderizar();
      const paso = (momento) => {
        let sigue = false;
        this.piezas.forEach((p) => {
          p.t = plegadoLimitar((momento - p.inicio) / this.duracion, 0, 1);
          if (p.t < 1) sigue = true;
        });
        this.renderizar();
        this.raf = sigue ? requestAnimationFrame(paso) : 0;
      };
      this.raf = requestAnimationFrame(paso);
    }

    mostrarYa() {
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.piezas.forEach((p) => {
        p.t = 1;
        p.f = 0;
      });
      this.renderizar();
    }

    medir(caja) {
      this.centros = this.piezas.map((p) => {
        const rect = p.pieza.parentElement.getBoundingClientRect();
        return { x: rect.left - caja.left + rect.width / 2, y: rect.top - caja.top + rect.height / 2 };
      });
      this.medida = { ancho: caja.width, alto: caja.height };
    }

    apuntar() {
      const caja = this.el.getBoundingClientRect();
      const cerca =
        this.puntero &&
        caja.width > 0 &&
        this.puntero.x > caja.left - this.radio &&
        this.puntero.x < caja.right + this.radio &&
        this.puntero.y > caja.top - this.radio &&
        this.puntero.y < caja.bottom + this.radio;
      if (cerca && (!this.centros || Math.abs(caja.width - this.medida.ancho) + Math.abs(caja.height - this.medida.alto) > 1)) {
        this.medir(caja);
      }
      let cambia = false;
      this.piezas.forEach((p, i) => {
        let valor = 0;
        if (cerca) {
          const centro = this.centros[i];
          const distancia = Math.hypot(caja.left + centro.x - this.puntero.x, caja.top + centro.y - this.puntero.y) / this.radio;
          if (distancia < 1) valor = 1 - distancia * distancia * (3 - 2 * distancia);
        }
        if (valor !== p.objetivo) cambia = true;
        p.objetivo = valor;
      });
      if (cambia && !this.rafRaton) {
        let previo = performance.now();
        const relajar = (momento) => {
          const paso = Math.min(momento - previo, 64) / 1000;
          previo = momento;
          let sigue = false;
          this.piezas.forEach((p) => {
            const ritmo = p.objetivo > p.r ? 14 : 6;
            p.r += (p.objetivo - p.r) * (1 - Math.exp(-ritmo * paso));
            if (Math.abs(p.objetivo - p.r) > 0.001) sigue = true;
            else p.r = p.objetivo;
          });
          if (!this.raf) this.renderizar();
          this.rafRaton = sigue ? requestAnimationFrame(relajar) : 0;
        };
        this.rafRaton = requestAnimationFrame(relajar);
      }
    }

    destruir() {
      cancelAnimationFrame(this.raf);
      cancelAnimationFrame(this.rafRaton);
      this.raf = 0;
      this.rafRaton = 0;
      if (this.alMover) {
        window.removeEventListener('pointermove', this.alMover);
        window.removeEventListener('scroll', this.alDesplazar, { capture: true });
        document.documentElement.removeEventListener('pointerleave', this.alSalir);
      }
    }
  }

  class BannerPrincipal extends HTMLElement {
    connectedCallback() {
      this.diapositivas = Array.from(this.querySelectorAll('[data-diapositiva]'));
      this.textos = Array.from(this.querySelectorAll('[data-texto]'));
      this.titulosSueltos = Array.from(this.querySelectorAll('[data-titulo-suelto]'));
      this.indice = 0;

      const segundos = parseFloat(this.dataset.segundos);
      this.intervalo = (isNaN(segundos) || segundos <= 0 ? 5 : segundos) * 1000;
      this.rotacionPedida = this.dataset.rotacion !== 'false' && this.diapositivas.length > 1;
      this.dondeRota = this.dataset.dondeRota || 'ambos';
      this.movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.escritorio = window.matchMedia('(min-width: 990px)');

      this.alCambiarAncho = () => this.evaluar();
      this.escritorio.addEventListener('change', this.alCambiarAncho);

      this.alCambiarVisibilidad = () => (document.hidden ? this.parar() : this.evaluar());
      document.addEventListener('visibilitychange', this.alCambiarVisibilidad);

      this.prepararPlegado();
      this.evaluar();
      this.prepararTarjeta();
      this.prepararBrillo();
    }

    disconnectedCallback() {
      this.parar();
      clearTimeout(this.temporizadorTarjeta);
      this.escritorio.removeEventListener('change', this.alCambiarAncho);
      document.removeEventListener('visibilitychange', this.alCambiarVisibilidad);
      this.destruirPlegado();
      this.destruirBrillo();
    }

    puedeRotarAqui() {
      if (this.dondeRota === 'ninguno') return false;
      if (this.dondeRota === 'escritorio') return this.escritorio.matches;
      if (this.dondeRota === 'movil') return !this.escritorio.matches;
      return true;
    }

    evaluar() {
      if (this.rotacionPedida && !this.movimientoReducido && this.puedeRotarAqui() && !document.hidden) {
        this.iniciar();
      } else {
        this.parar();
        this.mostrar(0);
      }
    }

    iniciar() {
      this.parar();
      this.temporizador = setInterval(() => this.siguiente(), this.intervalo);
    }

    parar() {
      if (this.temporizador) {
        clearInterval(this.temporizador);
        this.temporizador = null;
      }
    }

    siguiente() {
      this.mostrar((this.indice + 1) % this.diapositivas.length);
    }

    mostrar(nuevo) {
      const anterior = this.indice;
      this.diapositivas.forEach((slide, i) => {
        slide.classList.toggle('esta-saliendo', i === anterior && i !== nuevo);
        slide.classList.toggle('esta-activa', i === nuevo);
      });
      this.textos.forEach((texto, i) => texto.classList.toggle('esta-activa', i === nuevo));
      this.titulosSueltos.forEach((suelto) => {
        suelto.classList.toggle('esta-activa', Number(suelto.dataset.indice) === nuevo);
      });
      this.indice = nuevo;
      this.aplicarColocacion(this.textos[nuevo]);
      if (nuevo !== anterior) this.reproducirPlegado(nuevo, false);
    }

    prepararPlegado() {
      this.plegadosTitulo = [];
      this.plegadoValoracion = null;
      this.plegadoBoton = null;
      this.plegadoIniciado = false;
      const nodo = this.querySelector('[data-plegado-config]');
      if (!nodo) return;
      let config;
      try {
        config = JSON.parse(nodo.textContent);
      } catch (error) {
        console.warn('[banner-principal] Configuración del plegado no válida', error);
        return;
      }
      this.configPlegado = config;
      const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches && !config.ignorarReducido;
      const opciones = Object.assign({}, config, { reducido });
      const crear = (elemento) => {
        if (!elemento || elemento.hasAttribute('data-plegado-listo')) return null;
        try {
          const plegado = new BannerPrincipalPlegado(elemento, opciones);
          elemento.setAttribute('data-plegado-listo', '');
          return plegado;
        } catch (error) {
          console.warn('[banner-principal] No se pudo preparar el plegado', error);
          return null;
        }
      };

      this.plegadosTitulo = this.textos.map((texto, i) => {
        const lista = [crear(texto.querySelector('[data-plegable="titulo"]'))];
        this.titulosSueltos.forEach((suelto) => {
          if (Number(suelto.dataset.indice) === i && suelto.matches('[data-plegable="titulo"]')) lista.push(crear(suelto));
        });
        return lista.filter(Boolean);
      });
      this.plegadoValoracion = crear(this.querySelector('[data-plegable="valoracion"]'));
      this.plegadoBoton = crear(this.querySelector('[data-plegable="boton"]'));

      this.observadorPlegado = new IntersectionObserver(
        (entradas) => {
          if (!entradas.some((entrada) => entrada.isIntersecting)) return;
          this.observadorPlegado.disconnect();
          this.observadorPlegado = null;
          this.plegadoIniciado = true;
          this.reproducirPlegado(this.indice, true);
        },
        { threshold: 0.15 }
      );
      this.observadorPlegado.observe(this);
    }

    reproducirPlegado(indice, inicial) {
      if (!this.plegadoIniciado || !this.configPlegado) return;
      (this.plegadosTitulo[indice] || []).forEach((plegado) => plegado.reproducir(0));
      if (inicial || this.configPlegado.repetir) {
        if (this.plegadoValoracion) this.plegadoValoracion.reproducir(this.configPlegado.retardoValoracion);
        if (this.plegadoBoton) this.plegadoBoton.reproducir(this.configPlegado.retardoBoton);
      }
    }

    prepararBrillo() {
      this.brillo = null;
      const boton = this.querySelector('.banner-principal__boton');
      const nodo = this.querySelector('[data-brillo-config]');
      if (!boton || !nodo || typeof window.WebGL2RenderingContext === 'undefined') return;
      let ajustes;
      try {
        ajustes = JSON.parse(nodo.textContent);
      } catch (error) {
        console.warn('[banner-principal] Configuración del brillo no válida', error);
        return;
      }
      try {
        this.brillo = new BannerPrincipalBrillo(boton, ajustes);
        boton.setAttribute('data-brillo-activo', '');
      } catch (error) {
        this.brillo = null;
        console.warn('[banner-principal] Brillo del botón desactivado: ' + error.message);
      }
    }

    destruirBrillo() {
      if (!this.brillo) return;
      this.brillo.destruir();
      this.brillo = null;
    }

    destruirPlegado() {
      if (this.observadorPlegado) {
        this.observadorPlegado.disconnect();
        this.observadorPlegado = null;
      }
      (this.plegadosTitulo || []).forEach((lista) => lista.forEach((plegado) => plegado.destruir()));
      [this.plegadoValoracion, this.plegadoBoton].forEach((plegado) => {
        if (plegado) plegado.destruir();
      });
    }

    aplicarColocacion(texto) {
      const zona = this.querySelector('[data-textos]');
      if (!zona || !texto) return;

      const mapa = {
        '--bpt-margen-izq': texto.dataset.margenIzq,
        '--bpt-margen-der': texto.dataset.margenDer,
        '--bpt-pos-vertical': texto.dataset.posVertical,
        '--bpt-desplazamiento': texto.dataset.desplazamiento,
        '--bpt-ancho': texto.dataset.ancho,
        '--bpt-alinea-texto': texto.dataset.alineaTexto,
        '--bpt-alinea-flex': texto.dataset.alineaFlex,
        '--bpt-m-margen-izq': texto.dataset.mMargenIzq,
        '--bpt-m-margen-der': texto.dataset.mMargenDer,
        '--bpt-m-pos-vertical': texto.dataset.mPosVertical,
        '--bpt-m-desplazamiento': texto.dataset.mDesplazamiento,
        '--bpt-m-ancho': texto.dataset.mAncho,
        '--bpt-m-alinea-texto': texto.dataset.mAlineaTexto,
        '--bpt-m-alinea-flex': texto.dataset.mAlineaFlex,
      };

      Object.keys(mapa).forEach((variable) => {
        const valor = mapa[variable];
        if (valor) {
          zona.style.setProperty(variable, valor);
        } else {
          zona.style.removeProperty(variable);
        }
      });
    }

    prepararTarjeta() {
      this.tarjeta = this.querySelector('[data-tarjeta]');
      if (!this.tarjeta) return;

      const retardo = parseFloat(this.dataset.retardoTarjeta);
      this.temporizadorTarjeta = setTimeout(
        () => this.tarjeta.classList.add('esta-visible'),
        (isNaN(retardo) ? 0 : retardo) * 1000
      );

      const cerrar = this.querySelector('[data-cerrar-tarjeta]');
      if (cerrar) {
        cerrar.addEventListener('click', () => this.tarjeta.classList.add('esta-cerrada'));
      }
    }
  }

  if (!customElements.get('banner-principal')) {
    customElements.define('banner-principal', BannerPrincipal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-marquesina"] && !Shopify.designMode) return;
  try {
    
  class MarquesinaInfinita extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-marquesina-pista]');
      const lista = this.querySelector('[data-marquesina-lista]');
      if (!this.pista || !lista) return;

      this.plantilla = lista.cloneNode(true);
      this.velocidad = parseFloat(this.dataset.velocidad) || 60;

      this.construir();

      this.observador = new ResizeObserver(() => this.reprogramar());
      this.observador.observe(this);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.construir());
      }
    }

    disconnectedCallback() {
      if (this.observador) this.observador.disconnect();
      clearTimeout(this.temporizador);
    }

    reprogramar() {
      clearTimeout(this.temporizador);
      this.temporizador = setTimeout(() => this.construir(), 200);
    }

    construir() {
      const anchoVisible = this.offsetWidth || window.innerWidth;
      if (!anchoVisible) return;

      const medidor = this.plantilla.cloneNode(true);
      medidor.style.position = 'absolute';
      medidor.style.visibility = 'hidden';
      medidor.style.pointerEvents = 'none';

      this.pista.replaceChildren(medidor);
      const anchoLista = medidor.getBoundingClientRect().width;
      medidor.remove();

      if (!anchoLista) return;

      const copias = Math.max(1, Math.ceil(anchoVisible / anchoLista));
      const grupo = document.createElement('div');
      grupo.className = 'marquesina__grupo';

      for (let i = 0; i < copias; i++) {
        grupo.appendChild(this.plantilla.cloneNode(true));
      }

      const duplicado = grupo.cloneNode(true);
      duplicado.setAttribute('aria-hidden', 'true');

      this.pista.replaceChildren(grupo, duplicado);

      grupo.querySelectorAll('[data-marquesina-lista]').forEach((nodo, indice) => {
        if (indice > 0) nodo.setAttribute('aria-hidden', 'true');
      });

      this.style.setProperty('--marquesina-duracion', anchoLista * copias / this.velocidad + 's');
    }
  }

  if (!customElements.get('marquesina-infinita')) {
    customElements.define('marquesina-infinita', MarquesinaInfinita);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-ventajas"] && !Shopify.designMode) return;
  try {
    
  class VentajasFranja extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.fichas = Array.from(this.querySelectorAll('[data-ficha]'));
      this.puntos = Array.from(this.querySelectorAll('[data-punto]'));
      if (!this.pista || this.fichas.length < 2) return;

      this.indice = 0;
      this.movil = window.matchMedia('(max-width: 749px)');
      this.movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const segundos = parseFloat(this.dataset.segundos);
      this.intervalo = (isNaN(segundos) || segundos <= 0 ? 4 : segundos) * 1000;
      this.rotacionPedida = this.dataset.rotacion !== 'false';

      this.puntos.forEach((punto) => {
        punto.addEventListener('click', () => {
          this.parar();
          this.ir(Number(punto.dataset.indice));
        });
      });

      this.alDesplazar = () => this.repasar();
      this.pista.addEventListener('scroll', this.alDesplazar, { passive: true });

      this.alTocar = () => this.parar();
      this.pista.addEventListener('pointerdown', this.alTocar);

      this.alCambiarAncho = () => this.evaluar();
      this.movil.addEventListener('change', this.alCambiarAncho);

      this.alCambiarVisibilidad = () => (document.hidden ? this.parar() : this.evaluar());
      document.addEventListener('visibilitychange', this.alCambiarVisibilidad);

      this.evaluar();
    }

    disconnectedCallback() {
      this.parar();
      if (this.pista) {
        this.pista.removeEventListener('scroll', this.alDesplazar);
        this.pista.removeEventListener('pointerdown', this.alTocar);
      }
      if (this.movil) this.movil.removeEventListener('change', this.alCambiarAncho);
      document.removeEventListener('visibilitychange', this.alCambiarVisibilidad);
    }

    evaluar() {
      if (this.rotacionPedida && !this.movimientoReducido && this.movil.matches && !document.hidden) {
        this.iniciar();
      } else {
        this.parar();
      }
    }

    iniciar() {
      this.parar();
      this.temporizador = setInterval(() => {
        this.ir((this.indice + 1) % this.fichas.length);
      }, this.intervalo);
    }

    parar() {
      if (this.temporizador) {
        clearInterval(this.temporizador);
        this.temporizador = null;
      }
    }

    ir(indice) {
      const ficha = this.fichas[indice];
      if (!ficha) return;
      const centro = ficha.offsetLeft - (this.pista.clientWidth - ficha.clientWidth) / 2;
      this.pista.scrollTo({ left: Math.max(0, centro), behavior: 'smooth' });
      this.indice = indice;
      this.pintar();
    }

    repasar() {
      const medio = this.pista.scrollLeft + this.pista.clientWidth / 2;
      let cerca = 0;
      let minimo = Infinity;
      this.fichas.forEach((ficha, i) => {
        const centro = ficha.offsetLeft + ficha.clientWidth / 2;
        const distancia = Math.abs(centro - medio);
        if (distancia < minimo) {
          minimo = distancia;
          cerca = i;
        }
      });
      if (cerca !== this.indice) {
        this.indice = cerca;
        this.pintar();
      }
    }

    pintar() {
      this.puntos.forEach((punto, i) => punto.classList.toggle('esta-activo', i === this.indice));
    }
  }

  if (!customElements.get('ventajas-franja')) {
    customElements.define('ventajas-franja', VentajasFranja);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruma-carrusel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('carrusel-lente')) return;

    const FIT_ASPECT = { portrait: 0.75, square: 1, landscape: 4 / 3 };
    const TAPS = 12;
    const PIXEL_BUDGET = 4.5e6;
    const INTRO_DURATION = { rise: 2.1, bloom: 1.6, spin: 2.2, deal: 1.5, fade: 0.35 };

    const wrap = (value, size) => ((((value + size / 2) % size) + size) % size) - size / 2;
    const clamp01 = (value) => Math.min(Math.max(value, 0), 1);
    const easeOut = (value) => 1 - Math.pow(1 - clamp01(value), 3);
    const easeOutQuint = (value) => 1 - Math.pow(1 - clamp01(value), 5);
    const easeInOut = (value) => {
      const t = clamp01(value);
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };

    const cardVertex = `#version 300 es
in vec3 position;
in vec2 uv;
uniform vec4 uRect;
uniform vec2 uResolution;
out vec2 vUv;
out vec2 vLocal;
void main() {
  vUv = uv;
  vLocal = vec2(position.x, -position.y) * uRect.zw;
  vec2 px = uRect.xy + vLocal;
  gl_Position = vec4(px.x / uResolution.x * 2.0 - 1.0, 1.0 - px.y / uResolution.y * 2.0, 0.0, 1.0);
}
`;

    const cardFragment = `#version 300 es
precision highp float;
uniform sampler2D tMap;
uniform vec2 uSize;
uniform vec2 uImage;
uniform float uRadius;
uniform float uAlpha;
uniform float uReady;
uniform float uShift;
uniform float uDpr;
uniform vec3 uPlaceholder;
in vec2 vUv;
in vec2 vLocal;
out vec4 fragColor;

float roundedBox(vec2 p, vec2 b, float r) {
  vec2 q = abs(p) - b + r;
  return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r;
}

void main() {
  float sd = roundedBox(vLocal, uSize * 0.5, min(uRadius, min(uSize.x, uSize.y) * 0.5));
  float mask = clamp(0.5 - sd * uDpr, 0.0, 1.0);
  vec2 local = vLocal / uSize + 0.5;
  float cardAspect = uSize.x / uSize.y;
  float imageAspect = uImage.x / max(uImage.y, 1.0);
  vec2 scale = imageAspect > cardAspect ? vec2(cardAspect / imageAspect, 1.0) : vec2(1.0, imageAspect / cardAspect);
  scale /= 1.08;
  vec2 uv = vec2(local.x, 1.0 - local.y);
  uv = (uv - 0.5) * scale + 0.5;
  uv.x += uShift * (1.0 - scale.x) * 0.5;
  vec3 image = texture(tMap, uv).rgb;
  vec3 color = mix(uPlaceholder, image, uReady);
  float alpha = mask * uAlpha;
  fragColor = vec4(color * alpha, alpha);
}
`;

    const lensVertex = `#version 300 es
in vec2 position;
void main() {
  gl_Position = vec4(position, 0.0, 1.0);
}
`;

    const lensFragment = `#version 300 es
precision highp float;
uniform sampler2D tScene;
uniform vec2 uResolution;
uniform float uDpr;
uniform vec2 uCenter;
uniform vec2 uHalf;
uniform float uAngle;
uniform float uExponent;
uniform float uInner;
uniform float uOuter;
uniform float uFlow;
uniform float uCurl;
uniform float uDispersion;
uniform float uStrength;
uniform float uSceneAlpha;
out vec4 fragColor;

void main() {
  vec2 frag = gl_FragCoord.xy / uDpr;
  vec2 uv = frag / uResolution;
  vec2 rel = frag - vec2(uCenter.x, uResolution.y - uCenter.y);
  float ca = cos(uAngle);
  float sa = sin(uAngle);
  vec2 local = vec2(ca * rel.x + sa * rel.y, -sa * rel.x + ca * rel.y);
  vec2 k = max(abs(local) / uHalf, vec2(1e-5));
  float nd = pow(pow(k.x, uExponent) + pow(k.y, uExponent), 1.0 / uExponent);
  vec2 grad = pow(k, vec2(uExponent - 1.0)) * sign(local) / uHalf * pow(nd, 1.0 - uExponent);
  float glen = max(length(grad), 1e-6);
  float edge = (nd - 1.0) / glen;
  vec2 outward = grad / glen;
  vec2 normal = vec2(ca * outward.x - sa * outward.y, sa * outward.x + ca * outward.y);
  vec2 along = vec2(-normal.y, normal.x);

  float t = clamp((edge + uInner) / (uInner + uOuter), 0.0, 1.0);
  float ramp = t * t * t * (t * (t * 6.0 - 15.0) + 10.0);
  float slope = 16.0 * t * t * (1.0 - t) * (1.0 - t);
  float reachX = rel.x / (uResolution.x * 0.5);
  float side = smoothstep(0.02, 0.3, abs(reachX)) * (uCurl == 0.0 ? sign(reachX) : uCurl);
  float lift = ramp * side * uFlow * uStrength;
  vec2 swirl = along * along.y * side * slope * uFlow * uStrength * 0.35;
  vec2 drift = vec2(0.0, -lift) - swirl;
  vec2 shifted = uv + drift / uResolution;

  vec2 texels = uResolution * uDpr;
  vec2 gx = dFdx(shifted);
  vec2 gy = dFdy(shifted);
  gx *= min(1.0, 3.0 / max(length(gx * texels), 1e-4));
  gy *= min(1.0, 3.0 / max(length(gy * texels), 1e-4));

  vec4 color = textureGrad(tScene, shifted, gx, gy);
  vec2 spread = vec2(0.0, side * slope * uFlow * uStrength) / uResolution * uDispersion;
  float spreadPx = length(spread * texels);
  if (color.a > 0.002 && spreadPx > 0.25) {
    vec3 base = color.rgb / color.a;
    vec3 sumColor = vec3(0.0);
    vec3 sumWeight = vec3(0.0);
    for (int i = 0; i < ${TAPS}; i++) {
      float s = (float(i) + 0.5) / float(${TAPS});
      vec4 c = textureGrad(tScene, shifted + spread * (s - 0.5), gx, gy);
      vec3 w = max(1.0 - abs(vec3(s) - vec3(0.15, 0.5, 0.85)) * 2.6, 0.0) * c.a;
      sumColor += c.rgb * (w / max(c.a, 0.002));
      sumWeight += w;
    }
    vec3 split = mix(base, sumColor / max(sumWeight, vec3(1e-4)), clamp(sumWeight * 2.0, 0.0, 1.0));
    color.rgb = mix(color.rgb, clamp(split, 0.0, 1.0) * color.a, smoothstep(0.25, 1.5, spreadPx));
  }

  fragColor = color * uSceneAlpha;
}
`;

    const compilarShader = (gl, tipo, fuente) => {
      const shader = gl.createShader(tipo);
      gl.shaderSource(shader, fuente);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        const registro = gl.getShaderInfoLog(shader);
        gl.deleteShader(shader);
        throw new Error('Shader: ' + registro);
      }
      return shader;
    };

    const crearPrograma = (gl, vertice, fragmento) => {
      const vs = compilarShader(gl, gl.VERTEX_SHADER, vertice);
      const fs = compilarShader(gl, gl.FRAGMENT_SHADER, fragmento);
      const programa = gl.createProgram();
      gl.attachShader(programa, vs);
      gl.attachShader(programa, fs);
      gl.linkProgram(programa);
      gl.deleteShader(vs);
      gl.deleteShader(fs);
      if (!gl.getProgramParameter(programa, gl.LINK_STATUS)) {
        const registro = gl.getProgramInfoLog(programa);
        gl.deleteProgram(programa);
        throw new Error('Programa: ' + registro);
      }
      const u = {};
      const total = gl.getProgramParameter(programa, gl.ACTIVE_UNIFORMS);
      for (let i = 0; i < total; i++) {
        const info = gl.getActiveUniform(programa, i);
        if (info) u[info.name] = gl.getUniformLocation(programa, info.name);
      }
      return { programa, u };
    };

    const crearMotor = (host) => {
      const container = host.escena;
      const canvas = document.createElement('canvas');
      canvas.className = 'carrusel-lente__lienzo';
      canvas.setAttribute('aria-hidden', 'true');
      const gl = canvas.getContext('webgl2', {
        alpha: true,
        premultipliedAlpha: true,
        antialias: false,
        depth: false,
        stencil: false,
        powerPreference: 'default'
      });
      if (!gl) throw new Error('WebGL2 no disponible');

      let cardProgram;
      let lensProgram;
      try {
        cardProgram = crearPrograma(gl, cardVertex, cardFragment);
        lensProgram = crearPrograma(gl, lensVertex, lensFragment);
      } catch (error) {
        gl.getExtension('WEBGL_lose_context')?.loseContext();
        throw error;
      }

      gl.disable(gl.DEPTH_TEST);
      gl.disable(gl.CULL_FACE);
      gl.clearColor(0, 0, 0, 0);

      const quadVao = gl.createVertexArray();
      gl.bindVertexArray(quadVao);
      const quadPos = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, quadPos);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-0.5, 0.5, 0, 0.5, 0.5, 0, -0.5, -0.5, 0, 0.5, -0.5, 0]), gl.STATIC_DRAW);
      const posLoc = gl.getAttribLocation(cardProgram.programa, 'position');
      gl.enableVertexAttribArray(posLoc);
      gl.vertexAttribPointer(posLoc, 3, gl.FLOAT, false, 0, 0);
      const quadUv = gl.createBuffer();
      const uvLoc = gl.getAttribLocation(cardProgram.programa, 'uv');
      if (uvLoc >= 0) {
        gl.bindBuffer(gl.ARRAY_BUFFER, quadUv);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 1, 1, 1, 0, 0, 1, 0]), gl.STATIC_DRAW);
        gl.enableVertexAttribArray(uvLoc);
        gl.vertexAttribPointer(uvLoc, 2, gl.FLOAT, false, 0, 0);
      }
      const quadIndex = gl.createBuffer();
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, quadIndex);
      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([0, 2, 1, 2, 3, 1]), gl.STATIC_DRAW);

      const triVao = gl.createVertexArray();
      gl.bindVertexArray(triVao);
      const triPos = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, triPos);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      const triLoc = gl.getAttribLocation(lensProgram.programa, 'position');
      gl.enableVertexAttribArray(triLoc);
      gl.vertexAttribPointer(triLoc, 2, gl.FLOAT, false, 0, 0);
      gl.bindVertexArray(null);

      const anisoExt =
        gl.getExtension('EXT_texture_filter_anisotropic') ||
        gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
      const anisotropy = anisoExt ? Math.min(8, gl.getParameter(anisoExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT) || 1) : 0;

      const crearTextura = () => {
        const textura = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, textura);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0]));
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        return textura;
      };

      const subirImagen = (textura, imagen) => {
        gl.bindTexture(gl.TEXTURE_2D, textura);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, 4);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, imagen);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.generateMipmap(gl.TEXTURE_2D);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        if (anisotropy > 1) gl.texParameterf(gl.TEXTURE_2D, anisoExt.TEXTURE_MAX_ANISOTROPY_EXT, anisotropy);
      };

      const target = { texture: gl.createTexture(), fbo: gl.createFramebuffer(), width: 2, height: 2 };
      const setTargetSize = (w, h) => {
        target.width = w;
        target.height = h;
        gl.bindTexture(gl.TEXTURE_2D, target.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, w, h, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.bindFramebuffer(gl.FRAMEBUFFER, target.fbo);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      };
      setTargetSize(2, 2);

      const renderer = { dpr: 1 };
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

      let slots = [];
      let width = 1;
      let height = 1;
      let pos = 0;
      let vel = 0;
      let goal = 0;
      let mode = 'spring';
      let wheelAt = 0;
      let raf = 0;
      let last = performance.now();
      let visible = true;
      let alive = true;
      let dirty = true;
      let activeIndex = -1;
      let interactedAt = -Infinity;
      let autoplayAt = performance.now();
      let hasFocus = false;
      let deform = 0;
      let deformVel = 0;
      let layout = null;
      let resnap = false;
      let hover = '';
      let lift = 1;
      let energy = 0;
      let lastPos = 0;
      const lens = { x: 0, y: 0, vx: 0, vy: 0, ready: false };
      const pointer = {
        x: 0,
        y: 0,
        over: false,
        down: false,
        id: -1,
        startX: 0,
        startY: 0,
        startPos: 0,
        dragging: false,
        touch: false,
        samples: []
      };
      const introState = { kind: 'none', t: 0, running: false, done: false, readyAt: 0 };
      const focus = { index: -1, pending: -1, t: 0, v: 0, target: 0 };
      let instances = [];

      const settings = () => host.ajustesActuales;

      const loadSlot = (item, index) => {
        const texture = crearTextura();
        const placeholder = settings().colorHueco || [0.92, 0.9, 0.87];
        const slot = {
          item,
          index,
          texture,
          aspect: item.ancho && item.alto ? item.ancho / item.alto : 0.75,
          loaded: false,
          failed: false,
          ready: 0,
          color: placeholder.slice(),
          image: [item.ancho || 1, item.alto || 1],
          dispose: () => {}
        };
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.decoding = 'async';
        image.onload = () => {
          if (!alive || !slots.includes(slot)) return;
          try {
            subirImagen(texture, image);
          } catch (error) {
            slot.failed = true;
            host.usarAlternativa('No se pudo usar la imagen en WebGL: ' + item.src);
            return;
          }
          slot.image = [image.naturalWidth || 1, image.naturalHeight || 1];
          slot.aspect = slot.image[0] / slot.image[1];
          try {
            const probe = document.createElement('canvas');
            probe.width = 8;
            probe.height = 8;
            const ctx = probe.getContext('2d', { willReadFrequently: true });
            if (ctx) {
              ctx.drawImage(image, 0, 0, 8, 8);
              const data = ctx.getImageData(0, 0, 8, 8).data;
              const avg = [0, 0, 0];
              for (let i = 0; i < data.length; i += 4) {
                avg[0] += data[i];
                avg[1] += data[i + 1];
                avg[2] += data[i + 2];
              }
              slot.color = avg.map((v) => v / 64 / 255);
            }
          } catch (error) {
            slot.color = placeholder.slice();
          }
          slot.loaded = true;
          dirty = true;
          start();

        };
        image.onerror = () => {
          if (!alive) return;
          slot.failed = true;
          host.usarAlternativa('No se pudo cargar la imagen: ' + item.src);
        };
        image.src = width < 750 && item.srcMovil ? item.srcMovil : item.src;
        slot.dispose = () => {
          image.onload = null;
          image.onerror = null;
          gl.deleteTexture(texture);
        };
        return slot;
      };

      const setItems = (next) => {
        slots.forEach((slot) => slot.dispose());
        slots = next.map(loadSlot);
        activeIndex = -1;
        layout = null;
        resnap = true;
        focus.target = 0;
        focus.t = 0;
        focus.v = 0;
        focus.pending = -1;
        host.marcarEnfoque(false);
        introState.readyAt = performance.now();
        dirty = true;
        start();
      };

      const metrics = (s) => {
        const cardH = Math.max(24, s.cardHeight * height);
        const fixed = FIT_ASPECT[s.fit];
        const widths = slots.map((slot) => (fixed || slot.aspect) * cardH);
        const centers = [];
        let cursor = 0;
        for (let i = 0; i < widths.length; i++) {
          centers.push(cursor + widths[i] / 2);
          cursor += widths[i] + s.gap;
        }
        return { cardH, widths, centers, gap: s.gap, loop: Math.max(cursor, 1) };
      };

      const nearest = (m, at) => {
        let best = 0;
        let bestDist = Infinity;
        for (let i = 0; i < m.centers.length; i++) {
          const dist = Math.abs(wrap(m.centers[i] - at, m.loop));
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        }
        return best;
      };

      const snapPoint = (m, at) => {
        const i = nearest(m, at);
        return at + wrap(m.centers[i] - at, m.loop);
      };

      const remap = (from, to, at) => {
        const i = nearest(from, at);
        const offset = wrap(at - from.centers[i], from.loop);
        const cycles = Math.round((at - offset - from.centers[i]) / from.loop);
        return cycles * to.loop + to.centers[i] + offset * (to.widths[i] / from.widths[i]);
      };

      const step = (m, delta) => {
        let at = snapPoint(m, goal);
        let index = nearest(m, at);
        const n = m.centers.length;
        for (let k = 0; k < Math.abs(delta); k++) {
          const next = (index + (delta > 0 ? 1 : n - 1)) % n;
          const distance =
            delta > 0
              ? m.widths[index] / 2 + m.gap + m.widths[next] / 2
              : -(m.widths[next] / 2 + m.gap + m.widths[index] / 2);
          at += distance;
          index = next;
        }
        goal = at;
        mode = 'spring';
        dirty = true;
        start();
      };

      const goTo = (m, index) => {
        const i = ((index % m.centers.length) + m.centers.length) % m.centers.length;
        goal = goal + wrap(m.centers[i] - goal, m.loop);
        mode = 'spring';
        dirty = true;
        start();
      };

      const openFocus = (index) => {
        focus.index = index;
        focus.pending = -1;
        focus.target = 1;
        host.marcarEnfoque(true);
        dirty = true;
        start();
      };

      const closeFocus = () => {
        focus.pending = -1;
        if (focus.target === 0) return false;
        focus.target = 0;
        host.marcarEnfoque(false);
        dirty = true;
        start();
        return true;
      };

      const skipIntro = () => {
        if (introState.running) introState.t = 1;
      };

      const introEffects = () => {
        const t = introState.running ? introState.t : introState.done ? 1 : 0;
        const e = { sceneAlpha: 1, strength: 1, card: null };
        if (!introState.done && !introState.running) {
          e.sceneAlpha = 0;
          e.strength = 0;
          return e;
        }
        if (t >= 1) return e;
        const kind = introState.kind;
        if (kind === 'rise') {
          e.strength = easeInOut((t - 0.3) / 0.65);
          e.card = (rel) => {
            const delay = Math.min(Math.abs(rel) / (width * 0.6), 1) * 0.34;
            const local = clamp01((t - delay) / 0.6);
            return {
              alpha: clamp01(local * 4),
              x: 0,
              y: (1 - easeOutQuint(local)) * height * 0.62,
              scale: 0.5 + 0.5 * easeInOut((local - 0.18) / 0.82)
            };
          };
        } else if (kind === 'bloom') {
          e.strength = easeInOut((t - 0.2) / 0.8);
          e.card = (rel) => {
            const delay = Math.min(Math.abs(rel) / (width * 0.6), 1) * 0.25;
            const local = easeOut((t - delay) / 0.55);
            return { alpha: local, x: 0, y: 0, scale: 0.92 + 0.08 * local };
          };
        } else if (kind === 'spin') {
          e.sceneAlpha = easeOut(t / 0.25);
          e.strength = easeOut((t - 0.55) / 0.45);
        } else if (kind === 'deal') {
          e.strength = easeOut((t - 0.45) / 0.5);
          e.card = (rel) => {
            const spread = Math.min(Math.abs(rel) / (width * 0.6), 1) * 0.3;
            const local = easeOut((t - 0.12 - spread) / 0.5);
            return { alpha: easeOut((t - spread) / 0.12), x: -rel * (1 - local), y: 0, scale: 1 };
          };
        } else {
          e.sceneAlpha = easeOut(t);
          e.strength = easeOut(t);
        }
        return e;
      };

      const beginIntro = (s, m) => {
        const kind = reducedMotion && s.intro !== 'none' ? 'fade' : s.intro;
        introState.kind = INTRO_DURATION[kind] ? kind : 'none';
        introState.running = introState.kind !== 'none';
        introState.done = !introState.running;
        introState.t = 0;
        host.mostrarPie();
        if (introState.kind === 'spin') {
          const distance = m.loop * 1.6 + width;
          pos = goal + distance;
          vel = -distance * 3;
          mode = 'spring';
        }
      };

      const resize = () => {
        width = Math.max(1, container.clientWidth);
        height = Math.max(1, container.clientHeight);
        renderer.dpr = Math.min(window.devicePixelRatio || 1, 2, Math.sqrt(PIXEL_BUDGET / (width * height)));
        canvas.width = Math.max(1, Math.round(width * renderer.dpr));
        canvas.height = Math.max(1, Math.round(height * renderer.dpr));
        setTargetSize(Math.max(2, Math.round(width * renderer.dpr)), Math.max(2, Math.round(height * renderer.dpr)));
        dirty = true;
        start();
      };

      const drawCard = (slot, draw, clear, s, dpr) => {
        gl.bindFramebuffer(gl.FRAMEBUFFER, target.fbo);
        gl.viewport(0, 0, target.width, target.height);
        if (clear) gl.clear(gl.COLOR_BUFFER_BIT);
        const u = cardProgram.u;
        gl.useProgram(cardProgram.programa);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, slot.texture);
        gl.uniform1i(u.tMap, 0);
        gl.uniform4f(u.uRect, draw.x, draw.y, draw.cw + 2, draw.ch + 2);
        gl.uniform2f(u.uResolution, width, height);
        gl.uniform2f(u.uSize, draw.cw, draw.ch);
        gl.uniform2f(u.uImage, slot.image[0], slot.image[1]);
        gl.uniform1f(u.uRadius, s.radius);
        gl.uniform1f(u.uAlpha, draw.alpha);
        gl.uniform1f(u.uReady, slot.ready);
        gl.uniform1f(u.uShift, reducedMotion ? 0 : Math.max(-1, Math.min(1, draw.rel / (width * 0.75))));
        gl.uniform1f(u.uDpr, dpr);
        gl.uniform3f(u.uPlaceholder, slot.color[0], slot.color[1], slot.color[2]);
        gl.bindVertexArray(quadVao);
        gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
      };

      const frame = (now) => {
        raf = 0;
        if (!alive) return;
        const s = settings();
        const dt = Math.min(0.05, Math.max(0.001, (now - last) / 1000));
        last = now;
        if (!s || !slots.length) {
          if (visible) raf = requestAnimationFrame(frame);
          return;
        }

        const m = metrics(s);
        const n = slots.length;
        let animating = false;

        if (resnap) {
          goal = snapPoint(m, goal);
          pos = goal;
          vel = 0;
          resnap = false;
        } else if (layout && layout.loop !== m.loop) {
          pos = remap(layout, m, pos);
          goal = remap(layout, m, goal);
          pointer.startPos = pos + (pointer.x - pointer.startX);
          animating = true;
        }
        layout = m;

        if (!introState.running && !introState.done) {
          const allSettled = slots.every((slot) => slot.loaded || slot.failed);
          if (allSettled || now - introState.readyAt > 3500) {
            goal = snapPoint(m, goal);
            pos = goal;
            beginIntro(s, m);
          }
        }
        if (introState.running) {
          introState.t = Math.min(1, introState.t + dt / (INTRO_DURATION[introState.kind] || 1));
          if (introState.t >= 1) {
            introState.running = false;
            introState.done = true;
          }
          animating = true;
        }

        if (mode === 'wheel' && now - wheelAt > 150) {
          goal = snapPoint(m, goal);
          mode = 'spring';
        }
        if (!pointer.dragging) {
          const spinning = introState.running && introState.kind === 'spin';
          const stiffness = spinning ? 9 : mode === 'wheel' ? 80 : 55;
          const damping = 2 * Math.sqrt(stiffness);
          const steps = Math.ceil(dt / (1 / 240));
          const h = dt / steps;
          for (let i = 0; i < steps; i++) {
            const acc = stiffness * (goal - pos) - damping * vel;
            vel += acc * h;
            pos += vel * h;
          }
          if (Math.abs(goal - pos) < 0.05 && Math.abs(vel) < 0.5) {
            pos = goal;
            vel = 0;
          } else {
            animating = true;
          }
        } else {
          animating = true;
        }

        if (Math.abs(pos) > m.loop * 8) {
          const shift = Math.round(pos / m.loop) * m.loop;
          pos -= shift;
          goal -= shift;
          pointer.startPos -= shift;
        }

        const current = nearest(m, pos);
        if (current !== activeIndex) {
          activeIndex = current;
          host.actualizarPie(current);
        }

        if (focus.pending >= 0 && mode === 'spring' && Math.abs(goal - pos) < 1.5 && Math.abs(vel) < 30) {
          if (current === focus.pending) openFocus(current);
          else focus.pending = -1;
        }

        if (
          s.autoplay &&
          !reducedMotion &&
          introState.done &&
          focus.target === 0 &&
          focus.t < 0.01 &&
          !pointer.over &&
          !pointer.down &&
          !hasFocus &&
          mode === 'spring' &&
          Math.abs(goal - pos) < 1 &&
          now - interactedAt > 3000 &&
          now - autoplayAt > s.interval * 1000
        ) {
          autoplayAt = now;
          step(m, 1);
        }
        if (s.autoplay && !reducedMotion) animating = true;

        const travel = Math.abs(pos - lastPos) / dt;
        lastPos = pos;
        const energyTarget = reducedMotion ? 0 : Math.min(travel / 2600, 1);
        energy += (energyTarget - energy) * (1 - Math.exp(-dt / (energyTarget > energy ? 0.07 : 0.35)));
        if (energy > 0.001) animating = true;
        const liquidAmount = reducedMotion ? 0 : s.liquid;
        const push = Math.max(-1, Math.min(1, vel / 2200));
        const deformStiffness = 120;
        const deformDamping = 2 * Math.sqrt(deformStiffness) * 0.32;
        deformVel += (deformStiffness * (push - deform) - deformDamping * deformVel) * dt;
        deform += deformVel * dt;
        if (Math.abs(deform) > 0.0005 || Math.abs(deformVel) > 0.005) animating = true;

        const focusStiffness = 64;
        focus.v += (focusStiffness * (focus.target - focus.t) - 2 * Math.sqrt(focusStiffness) * focus.v) * dt;
        focus.t += focus.v * dt;
        if (Math.abs(focus.target - focus.t) < 0.0005 && Math.abs(focus.v) < 0.001) {
          focus.t = focus.target;
          focus.v = 0;
        } else {
          animating = true;
        }
        const focusAmount = clamp01(focus.t);
        const focusEase = easeInOut(focusAmount);
        const focusW = focus.index >= 0 && focus.index < n ? m.widths[focus.index] : m.cardH;
        const focusScale = Math.max(1, Math.min(1.3, (height * 0.84) / m.cardH, (width * 0.92) / focusW));
        const nextLift = 1 + (focusScale - 1) * focusEase;
        if (Math.abs(nextLift - lift) > 0.0005) {
          lift = nextLift;
          host.style.setProperty('--carrusel-lente-elevacion', lift.toFixed(4));
        }

        const effects = introEffects();

        const homeX = width / 2;
        const homeY = height / 2;
        const follow = s.followCursor && pointer.over && !pointer.dragging && !pointer.touch && focus.target === 0;
        const aimX = follow ? pointer.x : homeX;
        const aimY = follow ? pointer.y : homeY;
        if (!lens.ready) {
          lens.x = homeX;
          lens.y = homeY;
          lens.ready = true;
        }
        const lensK = 110;
        const lensC = 2 * Math.sqrt(lensK) * 0.8;
        lens.vx += (lensK * (aimX - lens.x) - lensC * lens.vx) * dt;
        lens.vy += (lensK * (aimY - lens.y) - lensC * lens.vy) * dt;
        lens.x += lens.vx * dt;
        lens.y += lens.vy * dt;
        if (Math.abs(aimX - lens.x) + Math.abs(aimY - lens.y) > 0.2 || Math.abs(lens.vx) + Math.abs(lens.vy) > 0.5)
          animating = true;

        const cardH = m.cardH;
        let halfW = (s.lensWidth * width) / 2;
        let halfH = (s.lensHeight * width) / 2;
        const squash = Math.abs(deform) * liquidAmount;
        halfW *= 1 + squash * 0.16;
        halfH *= 1 - squash * 0.08;
        const lensX = lens.x - deform * 14 * liquidAmount;

        for (let i = 0; i < n; i++) {
          const slot = slots[i];
          if (slot.loaded && slot.ready < 1) {
            slot.ready = Math.min(1, slot.ready + dt / 0.45);
            animating = true;
          }
        }

        const waiting = !introState.done;
        if (dirty || animating || pointer.dragging) {
          dirty = false;
          instances = [];
          const dpr = renderer.dpr;
          const shrink = 1 - clamp01(s.squeeze) * energy;
          const draws = [];
          for (let i = 0; i < n; i++) {
            const w = m.widths[i];
            const baseRel = wrap(m.centers[i] - pos, m.loop);
            for (let k = -3; k <= 3; k++) {
              const rel = baseRel + k * m.loop;
              if (Math.abs(rel) - w / 2 > width + 40) continue;
              const fx = effects.card ? effects.card(rel) : null;
              let x = homeX + rel + (fx ? fx.x : 0);
              let scale = shrink * (fx ? fx.scale : 1);
              let alpha = fx ? fx.alpha : 1;
              if (focusAmount > 0) {
                if (i === focus.index && Math.abs(rel) < w) {
                  scale *= 1 + (focusScale - 1) * focusEase;
                } else {
                  const order = Math.min(Math.abs(rel) / width, 1) * 0.25;
                  const part = easeInOut(focusAmount * 1.25 - order);
                  x += Math.sign(rel) * part * width * 0.7;
                  alpha *= 1 - part;
                }
              }
              const cw = w * scale;
              if (alpha <= 0.001 || x + cw / 2 < -40 || x - cw / 2 > width + 40) continue;
              draws.push({ i, rel, x, y: homeY + (fx ? fx.y : 0), cw, ch: cardH * scale, alpha });
            }
          }
          draws.sort((a, b) => Math.abs(b.rel) - Math.abs(a.rel));
          let first = true;
          for (const draw of draws) {
            const slot = slots[draw.i];
            drawCard(slot, draw, first, s, dpr);
            first = false;
            instances.push({
              index: draw.i,
              rel: draw.rel,
              x0: draw.x - draw.cw / 2,
              x1: draw.x + draw.cw / 2,
              y0: draw.y - draw.ch / 2,
              y1: draw.y + draw.ch / 2
            });
          }
          if (first) {
            gl.bindFramebuffer(gl.FRAMEBUFFER, target.fbo);
            gl.viewport(0, 0, target.width, target.height);
            gl.clear(gl.COLOR_BUFFER_BIT);
          }
          gl.bindFramebuffer(gl.FRAMEBUFFER, null);
          gl.activeTexture(gl.TEXTURE0);
          gl.bindTexture(gl.TEXTURE_2D, target.texture);
          gl.generateMipmap(gl.TEXTURE_2D);

          gl.viewport(0, 0, canvas.width, canvas.height);
          gl.clear(gl.COLOR_BUFFER_BIT);
          gl.disable(gl.BLEND);
          gl.useProgram(lensProgram.programa);
          const u = lensProgram.u;
          const spanW = Math.max(halfW, 1);
          const spanH = Math.max(halfH, 1);
          const inner = Math.max(4, s.reach * (spanW + spanH) * 0.5);
          gl.uniform1i(u.tScene, 0);
          gl.uniform2f(u.uResolution, width, height);
          gl.uniform1f(u.uDpr, dpr);
          gl.uniform2f(u.uCenter, lensX, lens.y);
          gl.uniform2f(u.uHalf, spanW, spanH);
          gl.uniform1f(u.uAngle, (s.tilt * Math.PI) / 180);
          gl.uniform1f(u.uExponent, 2 + Math.pow(1 - clamp01(s.roundness), 1.5) * 10);
          gl.uniform1f(u.uInner, inner);
          gl.uniform1f(u.uOuter, inner * 1.6);
          gl.uniform1f(u.uFlow, s.bend * (spanW + spanH) * 0.45);
          gl.uniform1f(u.uCurl, s.curl === 'rise' ? 1 : s.curl === 'fall' ? -1 : 0);
          gl.uniform1f(u.uDispersion, s.dispersion * 0.12 * (1 + Math.abs(deform) * liquidAmount * 1.2));
          gl.uniform1f(u.uStrength, (s.efectoLente ? 1 : 0) * effects.strength * (1 - focusEase));
          gl.uniform1f(u.uSceneAlpha, effects.sceneAlpha);
          gl.bindVertexArray(triVao);
          gl.drawArrays(gl.TRIANGLES, 0, 3);
          gl.bindVertexArray(null);

          if (host.colocarSello) {
            let elegida = null;
            for (const inst of instances) {
              if (inst.index !== activeIndex) continue;
              if (!elegida || Math.abs(inst.rel) < Math.abs(elegida.rel)) elegida = inst;
            }
            host.colocarSello(introState.done && focus.t < 0.5 ? elegida : null);
          }
        }

        let nextHover = '';
        if (pointer.over && !pointer.dragging && introState.done && s.focusOnClick) {
          const hit = instances.find(
            (inst) => pointer.x >= inst.x0 && pointer.x <= inst.x1 && pointer.y >= inst.y0 && pointer.y <= inst.y1
          );
          if (focus.target > 0) nextHover = 'cerrar';
          else if (hit) nextHover = 'abrir';
        }
        if (nextHover !== hover) {
          hover = nextHover;
          if (hover) container.setAttribute('data-puntero', hover);
          else container.removeAttribute('data-puntero');
        }

        if (visible && (animating || waiting || dirty || pointer.down)) raf = requestAnimationFrame(frame);
      };

      const start = () => {
        if (raf || !visible || !alive || document.hidden) return;
        last = performance.now();
        raf = requestAnimationFrame(frame);
      };

      const localPoint = (e) => {
        const rect = container.getBoundingClientRect();
        return [e.clientX - rect.left, e.clientY - rect.top];
      };

      const onPointerDown = (e) => {
        if (e.button !== undefined && e.button > 0) return;
        skipIntro();
        const [x, y] = localPoint(e);
        pointer.down = true;
        pointer.id = e.pointerId;
        pointer.touch = e.pointerType === 'touch';
        pointer.startX = x;
        pointer.startY = y;
        pointer.x = x;
        pointer.y = y;
        pointer.startPos = pos;
        pointer.dragging = false;
        pointer.samples = [{ x, t: performance.now() }];
        interactedAt = performance.now();
        if (Math.abs(vel) > 40) {
          goal = pos;
          vel = 0;
        }
        dirty = true;
        start();
      };

      const onPointerMove = (e) => {
        const [x, y] = localPoint(e);
        pointer.x = x;
        pointer.y = y;
        pointer.over = true;
        if (pointer.down && e.pointerId === pointer.id) {
          const dx = x - pointer.startX;
          const dy = y - pointer.startY;
          const slop = pointer.touch ? 10 : 5;
          if (!pointer.dragging) {
            if (pointer.touch && Math.abs(dy) > slop && Math.abs(dy) > Math.abs(dx)) {
              pointer.down = false;
              return;
            }
            if (Math.abs(dx) > slop) {
              pointer.dragging = true;
              pointer.startX = x;
              pointer.startPos = pos;
              closeFocus();
              try {
                container.setPointerCapture(e.pointerId);
              } catch (error) {
                pointer.dragging = true;
              }
              container.setAttribute('data-arrastrando', '');
            }
          }
          if (pointer.dragging) {
            pos = pointer.startPos - (x - pointer.startX);
            goal = pos;
            vel = 0;
            const now = performance.now();
            pointer.samples.push({ x, t: now });
            while (pointer.samples.length > 2 && now - pointer.samples[0].t > 100) pointer.samples.shift();
          }
        }
        dirty = true;
        start();
      };

      const onPointerUp = (e) => {
        if (!pointer.down || e.pointerId !== pointer.id) return;
        pointer.down = false;
        container.removeAttribute('data-arrastrando');
        const s = settings();
        if (!s) return;
        const m = metrics(s);
        interactedAt = performance.now();
        if (pointer.dragging) {
          pointer.dragging = false;
          const now = performance.now();
          const first = pointer.samples[0];
          const lastSample = pointer.samples[pointer.samples.length - 1];
          let velocity = 0;
          if (first && lastSample && lastSample.t > first.t && now - lastSample.t < 70) {
            velocity = -((lastSample.x - first.x) / (lastSample.t - first.t)) * 1000;
          }
          vel = velocity;
          const landing = snapPoint(m, pos + velocity * 0.32);
          goal = landing;
          if (Math.abs(velocity) > 400 && Math.abs(landing - pos) < 1) step(m, velocity > 0 ? 1 : -1);
          mode = 'spring';
          start();
          return;
        }
        if (closeFocus()) return;
        const [x, y] = localPoint(e);
        const hit = instances.find((inst) => x >= inst.x0 && x <= inst.x1 && y >= inst.y0 && y <= inst.y1);
        if (!hit) return;
        if (hit.index === activeIndex && Math.abs(goal - pos) < 2) {
          if (s.focusOnClick) openFocus(hit.index);
        } else {
          const rel = (hit.x0 + hit.x1) / 2 - width / 2;
          goal = snapPoint(m, pos + rel);
          mode = 'spring';
          if (s.focusOnClick) focus.pending = hit.index;
          start();
        }
      };

      const onPointerLeave = () => {
        pointer.over = false;
        dirty = true;
        start();
      };

      const onPointerCancel = () => {
        pointer.down = false;
        pointer.dragging = false;
        container.removeAttribute('data-arrastrando');
        const s = settings();
        if (!s) return;
        goal = snapPoint(metrics(s), pos);
        mode = 'spring';
        start();
      };

      const onWheel = (e) => {
        const s = settings();
        if (!s || e.ctrlKey) return;
        let dx = e.deltaX;
        let dy = e.deltaY;
        if (e.shiftKey && Math.abs(dx) < Math.abs(dy)) {
          dx = dy;
          dy = 0;
        }
        const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? height : 1;
        const horizontal = Math.abs(dx) > Math.abs(dy);
        if (!horizontal && !s.captureWheel) return;
        e.preventDefault();
        skipIntro();
        interactedAt = performance.now();
        if (closeFocus()) return;
        const delta = Math.max(-120, Math.min(120, (horizontal ? dx : dy) * unit));
        goal += delta * 1.25;
        mode = 'wheel';
        wheelAt = performance.now();
        start();
      };

      const onKeyDown = (e) => {
        const s = settings();
        if (!s) return;
        const m = metrics(s);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          skipIntro();
          closeFocus();
          interactedAt = performance.now();
          step(m, 1);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          skipIntro();
          closeFocus();
          interactedAt = performance.now();
          step(m, -1);
        } else if (e.key === 'Home') {
          e.preventDefault();
          closeFocus();
          goTo(m, 0);
        } else if (e.key === 'End') {
          e.preventDefault();
          closeFocus();
          goTo(m, slots.length - 1);
        } else if (e.key === 'Escape') {
          if (closeFocus()) e.preventDefault();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (closeFocus() || activeIndex < 0) return;
          if (s.focusOnClick) openFocus(activeIndex);
        }
      };

      const onFocus = () => {
        hasFocus = true;
      };
      const onBlur = () => {
        hasFocus = false;
      };
      const onVisibility = () => {
        if (!document.hidden) start();
      };
      const onContextLost = (e) => {
        e.preventDefault();
        host.usarAlternativa('Se perdió el contexto WebGL');
      };

      canvas.addEventListener('webglcontextlost', onContextLost);
      container.prepend(canvas);
      container.setAttribute('tabindex', '0');
      container.addEventListener('pointerdown', onPointerDown);
      container.addEventListener('pointermove', onPointerMove);
      container.addEventListener('pointerup', onPointerUp);
      container.addEventListener('pointerleave', onPointerLeave);
      container.addEventListener('pointercancel', onPointerCancel);
      container.addEventListener('wheel', onWheel, { passive: false });
      container.addEventListener('keydown', onKeyDown);
      container.addEventListener('focus', onFocus);
      container.addEventListener('blur', onBlur);
      document.addEventListener('visibilitychange', onVisibility);

      const resizeObserver = new ResizeObserver(resize);
      resizeObserver.observe(container);
      const intersectionObserver = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        start();
      });
      intersectionObserver.observe(container);

      resize();
      setItems(host.fotos);

      return {
        anterior: () => {
          const s = settings();
          if (!s) return;
          skipIntro();
          closeFocus();
          interactedAt = performance.now();
          step(metrics(s), -1);
        },
        siguiente: () => {
          const s = settings();
          if (!s) return;
          skipIntro();
          closeFocus();
          interactedAt = performance.now();
          step(metrics(s), 1);
        },
        irA: (index) => {
          const s = settings();
          if (!s) return;
          skipIntro();
          closeFocus();
          interactedAt = performance.now();
          goTo(metrics(s), index);
        },
        despertar: () => {
          dirty = true;
          start();
        },
        destruir: () => {
          alive = false;
          visible = false;
          cancelAnimationFrame(raf);
          raf = 0;
          resizeObserver.disconnect();
          intersectionObserver.disconnect();
          canvas.removeEventListener('webglcontextlost', onContextLost);
          container.removeEventListener('pointerdown', onPointerDown);
          container.removeEventListener('pointermove', onPointerMove);
          container.removeEventListener('pointerup', onPointerUp);
          container.removeEventListener('pointerleave', onPointerLeave);
          container.removeEventListener('pointercancel', onPointerCancel);
          container.removeEventListener('wheel', onWheel);
          container.removeEventListener('keydown', onKeyDown);
          container.removeEventListener('focus', onFocus);
          container.removeEventListener('blur', onBlur);
          document.removeEventListener('visibilitychange', onVisibility);
          container.removeAttribute('tabindex');
          container.removeAttribute('data-puntero');
          container.removeAttribute('data-arrastrando');
          if (host.colocarSello) host.colocarSello(null);
          slots.forEach((slot) => slot.dispose());
          slots = [];
          gl.deleteTexture(target.texture);
          gl.deleteFramebuffer(target.fbo);
          [quadPos, quadUv, quadIndex, triPos].forEach((buffer) => gl.deleteBuffer(buffer));
          gl.deleteVertexArray(quadVao);
          gl.deleteVertexArray(triVao);
          gl.deleteProgram(cardProgram.programa);
          gl.deleteProgram(lensProgram.programa);
          gl.getExtension('WEBGL_lose_context')?.loseContext();
          if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
        }
      };
    };

    class CarruselLente extends HTMLElement {
      connectedCallback() {
        this.escena = this.querySelector('[data-escena]');
        if (!this.escena) return;
        this.pista = this.querySelector('[data-pista]');
        this.pie = this.querySelector('[data-pie]');
        this.vivo = this.querySelector('[data-vivo]');
        this.contador = this.querySelector('[data-contador]');
        this.digitos = this.querySelector('[data-digitos]');
        this.totalTexto = this.querySelector('[data-total]');
        this.tituloFoto = this.querySelector('[data-titulo-foto]');
        this.flechas = Array.from(this.querySelectorAll('[data-ir]'));
        this.sello = this.querySelector('[data-sello-motor]');

        this.fotos = Array.from(this.querySelectorAll('[data-foto]')).map((ficha) => ({
          id: ficha.dataset.bloque || '',
          src: ficha.dataset.src || '',
          srcMovil: ficha.dataset.srcMovil || '',
          ancho: Number(ficha.dataset.ancho) || 1,
          alto: Number(ficha.dataset.alto) || 1,
          alt: ficha.dataset.alt || '',
          enlace: ficha.dataset.enlace || '',
          descuento: Number(ficha.dataset.descuento) || 0,
          precios: ficha.querySelector('[data-precios]'),
          titulo: ficha.dataset.titulo || '',
          subtitulo: ficha.dataset.subtitulo || ''
        })).filter((foto) => foto.src);
        this.config = this.leerJson('[data-carrusel-config]', null);
        if (!Array.isArray(this.fotos) || !this.fotos.length || !this.config) return;

        this.consulta = window.matchMedia('(min-width: 990px)');
        this.alCambiarConsulta = () => {
          this.recalcularAjustes();
          if (this.motor) this.motor.despertar();
        };
        this.consulta.addEventListener('change', this.alCambiarConsulta);
        this.recalcularAjustes();

        this.prepararContador();
        this.actualizarPie(0, true);

        this.alPulsarFlecha = (evento) => {
          const sentido = Number(evento.currentTarget.dataset.ir);
          if (this.motor) {
            if (sentido < 0) this.motor.anterior();
            else this.motor.siguiente();
          } else {
            this.desplazarAlternativa(sentido);
          }
        };
        this.flechas.forEach((flecha) => flecha.addEventListener('click', this.alPulsarFlecha));

        this.alSeleccionarBloque = (evento) => {
          const detalle = evento.detail || {};
          if (detalle.sectionId !== this.dataset.seccion) return;
          const indice = this.fotos.findIndex((foto) => foto.id === detalle.blockId);
          if (indice < 0) return;
          if (this.motor) {
            this.motor.irA(indice);
          } else {
            const ficha = this.pista && this.pista.children[indice];
            if (ficha) ficha.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        };
        document.addEventListener('shopify:block:select', this.alSeleccionarBloque);

        if (typeof window.WebGL2RenderingContext === 'undefined') {
          this.usarAlternativa('El navegador no admite WebGL2');
          return;
        }

        this.escena.setAttribute('data-motor', 'webgl');
        this.observadorInicio = new IntersectionObserver(
          (entradas) => {
            if (!entradas.some((entrada) => entrada.isIntersecting)) return;
            this.observadorInicio.disconnect();
            this.observadorInicio = null;
            this.arrancarMotor();
          },
          { rootMargin: '400px 0px' }
        );
        this.observadorInicio.observe(this);
      }

      disconnectedCallback() {
        if (this.observadorInicio) {
          this.observadorInicio.disconnect();
          this.observadorInicio = null;
        }
        if (this.consulta && this.alCambiarConsulta) {
          this.consulta.removeEventListener('change', this.alCambiarConsulta);
        }
        if (this.flechas && this.alPulsarFlecha) {
          this.flechas.forEach((flecha) => flecha.removeEventListener('click', this.alPulsarFlecha));
        }
        if (this.alSeleccionarBloque) {
          document.removeEventListener('shopify:block:select', this.alSeleccionarBloque);
        }
        this.pararMotor();
      }

      leerJson(selector, porDefecto) {
        const nodo = this.querySelector(selector);
        if (!nodo) return porDefecto;
        try {
          return JSON.parse(nodo.textContent);
        } catch (error) {
          console.warn('[carrusel-lente] Datos no válidos en ' + selector, error);
          return porDefecto;
        }
      }

      recalcularAjustes() {
        const base = this.consulta.matches ? this.config.escritorio : this.config.movil;
        this.ajustesActuales = Object.assign({}, this.config.comun, base);
      }

      arrancarMotor() {
        if (this.motor || !this.isConnected) return;
        try {
          this.motor = crearMotor(this);
        } catch (error) {
          this.motor = null;
          this.usarAlternativa(error && error.message ? error.message : 'Error al iniciar WebGL2');
        }
      }

      pararMotor() {
        if (!this.motor) return;
        const motor = this.motor;
        this.motor = null;
        motor.destruir();
      }

      usarAlternativa(motivo) {
        if (this.enAlternativa) return;
        this.enAlternativa = true;
        if (motivo) console.warn('[carrusel-lente] Modo alternativo: ' + motivo);
        if (this.sello) this.sello.removeAttribute('data-visible');
        if (this.observadorInicio) {
          this.observadorInicio.disconnect();
          this.observadorInicio = null;
        }
        const pararAhora = () => {
          this.pararMotor();
          if (this.escena) this.escena.removeAttribute('data-motor');
          if (this.pie) this.pie.removeAttribute('data-visible');
        };
        if (this.motor) queueMicrotask(pararAhora);
        else pararAhora();
      }

      desplazarAlternativa(sentido) {
        if (!this.pista) return;
        const ficha = this.pista.querySelector('.carrusel-lente__ficha');
        const estilo = window.getComputedStyle(this.pista);
        const hueco = parseFloat(estilo.columnGap || estilo.gap) || 0;
        const paso = ficha ? ficha.getBoundingClientRect().width + hueco : this.pista.clientWidth * 0.8;
        this.pista.scrollBy({ left: paso * sentido, behavior: 'smooth' });
      }

      prepararContador() {
        if (this.totalTexto) this.totalTexto.textContent = String(this.fotos.length).padStart(2, '0');
        if (!this.digitos) return;
        const cifras = Math.max(2, String(this.fotos.length).length);
        this.digitos.textContent = '';
        this.carretes = [];
        for (let i = 0; i < cifras; i++) {
          const digito = document.createElement('span');
          digito.className = 'carrusel-lente__digito';
          const carrete = document.createElement('span');
          carrete.className = 'carrusel-lente__carrete';
          for (let n = 0; n <= 9; n++) {
            const numero = document.createElement('span');
            numero.textContent = String(n);
            carrete.appendChild(numero);
          }
          digito.appendChild(carrete);
          this.digitos.appendChild(digito);
          this.carretes.push(carrete);
        }
      }

      colocarSello(caja) {
        if (!this.sello) return;
        if (!caja) {
          this.sello.removeAttribute('data-visible');
          return;
        }
        const foto = this.fotos[caja.index];
        if (!foto || !foto.descuento) {
          this.sello.removeAttribute('data-visible');
          return;
        }
        const texto = '-' + foto.descuento + '%';
        if (this.sello.textContent !== texto) this.sello.textContent = texto;
        const s = this.ajustesActuales || {};
        const esquina = s.selloEsquina || 'arriba_derecha';
        const margen = (caja.x1 - caja.x0) * (s.selloMargen || 0);
        const dx = s.selloDx || 0;
        const dy = s.selloDy || 0;
        const derecha = esquina.indexOf('derecha') >= 0;
        const abajo = esquina.indexOf('abajo') >= 0;
        const x = (derecha ? caja.x1 - margen : caja.x0 + margen) + dx;
        const y = (abajo ? caja.y1 - margen : caja.y0 + margen) + dy;
        this.sello.style.setProperty('--sello-x', x + 'px');
        this.sello.style.setProperty('--sello-y', y + 'px');
        this.sello.style.setProperty(
          '--sello-tr',
          'translate(' + (derecha ? '-100%' : '0px') + ', ' + (abajo ? '-100%' : '0px') + ')'
        );
        this.sello.setAttribute('data-visible', '');
      }

      mostrarPie() {
        if (this.pie) this.pie.setAttribute('data-visible', '');
      }

      textoAccesible(foto, indice) {
        const partes = [foto.titulo || foto.alt || 'Imagen ' + (indice + 1)];
        if (foto.precios) {
          const leer = (clase) => {
            const nodo = foto.precios.querySelector('.carrusel-lente__' + clase);
            return nodo ? nodo.textContent.replace(/\s+/g, ' ').trim() : '';
          };
          const ahora = leer('precio');
          const antes = leer('precio-antes');
          const descuento = leer('descuento');
          if (ahora) partes.push(ahora);
          if (antes) partes.push('antes ' + antes);
          if (descuento) partes.push(descuento.replace('-', '') + ' de descuento');
        }
        partes.push(indice + 1 + ' de ' + this.fotos.length);
        return partes.join(', ');
      }

      marcarEnfoque(abierto) {
        if (!this.contador) return;
        if (abierto) this.contador.setAttribute('data-oculto', '');
        else this.contador.removeAttribute('data-oculto');
      }

      actualizarPie(indice, inicial) {
        const foto = this.fotos[indice] || this.fotos[0];
        if (!foto) return;
        if (this.tituloFoto) {
          const nuevo = document.createElement('span');
          nuevo.className = 'carrusel-lente__titulo-foto';
          nuevo.setAttribute('data-titulo-foto', '');
          let destino = nuevo;
          if (foto.enlace) {
            const enlace = document.createElement('a');
            enlace.className = 'carrusel-lente__enlace-pie';
            enlace.href = foto.enlace;
            nuevo.appendChild(enlace);
            destino = enlace;
          }
          if (foto.titulo) {
            const nombre = document.createElement('span');
            nombre.className = 'carrusel-lente__nombre';
            nombre.textContent = foto.titulo;
            destino.appendChild(nombre);
          }
          if (foto.subtitulo) {
            const sub = document.createElement('span');
            sub.className = 'carrusel-lente__subtitulo-foto';
            sub.textContent = foto.subtitulo;
            destino.appendChild(sub);
          }
          if (foto.precios) {
            destino.appendChild(foto.precios.cloneNode(true));
          }
          if (!foto.titulo && !foto.subtitulo && !foto.precios) nuevo.style.display = 'none';
          this.tituloFoto.replaceWith(nuevo);
          this.tituloFoto = nuevo;
        }
        if (this.carretes) {
          const texto = String(indice + 1).padStart(this.carretes.length, '0');
          this.carretes.forEach((carrete, i) => {
            carrete.style.transform = 'translateY(' + -Number(texto[i]) * 10 + '%)';
          });
        }
        if (this.vivo && !inicial) {
          this.vivo.textContent = this.textoAccesible(foto, indice);
        }
      }
    }

    customElements.define('carrusel-lente', CarruselLente);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruma-instaporta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('muro-deriva')) return;

    const columnFactor = (index, variance) => {
      const pseudo = ((index * 0.6180339887 + 0.35) % 1) * 2 - 1;
      return 1 + variance * pseudo;
    };

    class MuroDeriva extends HTMLElement {
      connectedCallback() {
        this.muro = this.querySelector('[data-muro]');
        this.plano = this.querySelector('[data-plano]');
        if (!this.muro || !this.plano) return;

        this.items = Array.from(this.querySelectorAll('[data-ficha-origen]')).map((origen) => ({
          bloque: origen.dataset.bloque || '',
          src: origen.dataset.src || '',
          srcset: origen.dataset.srcset || '',
          ancho: Number(origen.dataset.ancho) || 600,
          alto: Number(origen.dataset.alto) || 800,
          alt: origen.dataset.alt || '',
          titulo: origen.dataset.titulo || '',
          enlace: origen.dataset.enlace || '',
          nuevaPestana: origen.dataset.nuevaPestana === 'true'
        })).filter((item) => item.src);
        if (!this.items.length) return;

        try {
          this.config = JSON.parse(this.querySelector('[data-muro-config]').textContent);
        } catch (error) {
          console.warn('[muro-deriva] Configuración no válida', error);
          return;
        }

        this.consulta = window.matchMedia('(min-width: 990px)');
        this.consultaReducida = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reducido = this.calcularReducido();

        this.offsets = [];
        this.velocities = [];
        this.tracks = [];
        this.columnMeta = [];
        this.baseVelocities = [];
        this.hoveredCol = -1;
        this.wallHovered = false;
        this.pointer = { x: 0, y: 0 };
        this.pointerDamped = { x: 0, y: 0 };
        this.lastTs = null;
        this.activa = null;
        this.visible = false;
        this.raf = 0;
        this.altoConstruido = 0;

        this.alCambiarConsulta = () => this.construir();
        this.alCambiarReducido = () => {
          this.reducido = this.calcularReducido();
          this.arrancar();
        };
        this.alMoverPuntero = (evento) => this.moverPuntero(evento);
        this.alEntrar = () => {
          this.wallHovered = true;
        };
        this.alSalir = () => {
          this.wallHovered = false;
          this.pointer = { x: 0, y: 0 };
          this.soltar();
        };
        this.alEnfocar = (evento) => {
          const ficha = evento.target.closest && evento.target.closest('[data-ficha]');
          if (ficha) this.activar(ficha);
        };
        this.alDesenfocar = () => this.soltar();
        this.alCambiarVisibilidad = () => {
          if (document.hidden) this.parar();
          else this.arrancar();
        };
        this.alSeleccionarBloque = (evento) => {
          const detalle = evento.detail || {};
          if (detalle.sectionId !== this.dataset.seccion) return;
          const ficha = this.plano.querySelector('[data-bloque="' + CSS.escape(detalle.blockId || '') + '"]');
          if (ficha) this.activar(ficha);
        };
        this.alDeseleccionarBloque = (evento) => {
          const detalle = evento.detail || {};
          if (detalle.sectionId === this.dataset.seccion) this.soltar();
        };

        this.consulta.addEventListener('change', this.alCambiarConsulta);
        this.consultaReducida.addEventListener('change', this.alCambiarReducido);
        this.muro.addEventListener('pointermove', this.alMoverPuntero);
        this.muro.addEventListener('pointerenter', this.alEntrar);
        this.muro.addEventListener('pointerleave', this.alSalir);
        this.plano.addEventListener('focusin', this.alEnfocar);
        this.plano.addEventListener('focusout', this.alDesenfocar);
        document.addEventListener('visibilitychange', this.alCambiarVisibilidad);
        document.addEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.addEventListener('shopify:block:deselect', this.alDeseleccionarBloque);

        this.observadorTamano = new ResizeObserver(() => {
          const alto = this.muro.clientHeight || 600;
          if (Math.abs(alto - this.altoConstruido) > 1) this.construir();
        });
        this.observadorTamano.observe(this.muro);

        this.observadorVista = new IntersectionObserver(
          ([entrada]) => {
            this.visible = entrada.isIntersecting;
            if (this.visible) this.arrancar();
            else this.parar();
          },
          { rootMargin: '200px 0px' }
        );
        this.observadorVista.observe(this.muro);

        this.construir();
        this.muro.setAttribute('data-listo', '');
      }

      disconnectedCallback() {
        this.parar();
        if (this.observadorTamano) this.observadorTamano.disconnect();
        if (this.observadorVista) this.observadorVista.disconnect();
        if (this.consulta) this.consulta.removeEventListener('change', this.alCambiarConsulta);
        if (this.consultaReducida) this.consultaReducida.removeEventListener('change', this.alCambiarReducido);
        if (this.muro && this.alMoverPuntero) {
          this.muro.removeEventListener('pointermove', this.alMoverPuntero);
          this.muro.removeEventListener('pointerenter', this.alEntrar);
          this.muro.removeEventListener('pointerleave', this.alSalir);
        }
        if (this.plano && this.alEnfocar) {
          this.plano.removeEventListener('focusin', this.alEnfocar);
          this.plano.removeEventListener('focusout', this.alDesenfocar);
        }
        if (this.alCambiarVisibilidad) document.removeEventListener('visibilitychange', this.alCambiarVisibilidad);
        if (this.alSeleccionarBloque) document.removeEventListener('shopify:block:select', this.alSeleccionarBloque);
        if (this.alDeseleccionarBloque) document.removeEventListener('shopify:block:deselect', this.alDeseleccionarBloque);
      }

      calcularReducido() {
        if (!this.consultaReducida.matches) return false;
        if (this.config.comun.ignorarReducido) return false;
        console.info('[muro-deriva] El dispositivo tiene activado reducir movimiento: el muro queda quieto. Puedes cambiarlo en los ajustes de la sección.');
        return true;
      }

      ajustes() {
        return Object.assign({}, this.config.comun, this.consulta.matches ? this.config.escritorio : this.config.movil);
      }

      construir() {
        const s = this.ajustes();
        this.s = s;
        const columns = Math.max(1, s.columns);
        const containerHeight = this.muro.clientHeight || 600;
        this.altoConstruido = containerHeight;

        const columnItems = Array.from({ length: columns }, () => []);
        this.items.forEach((item, i) => columnItems[i % columns].push(item));
        const cols = columnItems.map((col) => (col.length ? col : this.items.slice(0, 1)));

        const unit = s.tileHeight + s.gap;
        this.columnMeta = cols.map((col) => {
          const copyHeight = Math.max(unit, col.length * unit);
          const copies = Math.max(3, Math.ceil((containerHeight * 1.6) / copyHeight) + 2);
          return { copyHeight, copies };
        });

        const dirSign = s.direction === 'up' ? 1 : -1;
        this.baseVelocities = cols.map((_, c) => {
          const altSign = c % 2 === 0 ? 1 : -1;
          return s.speed * columnFactor(c, s.variance) * dirSign * altSign;
        });

        const previos = this.offsets.slice();
        this.offsets = this.columnMeta.map((meta, c) =>
          typeof previos[c] === 'number' ? previos[c] % meta.copyHeight : meta.copyHeight * ((c * 0.37) % 1)
        );
        this.velocities = cols.map(() => 0);
        this.activa = null;
        this.hoveredCol = -1;

        const fragmento = document.createDocumentFragment();
        this.tracks = [];
        cols.forEach((col, c) => {
          const columna = document.createElement('div');
          columna.className = 'muro-deriva__columna';
          const pista = document.createElement('div');
          pista.className = 'muro-deriva__pista';
          const meta = this.columnMeta[c];
          for (let copia = 0; copia < meta.copies; copia++) {
            col.forEach((item, itemIndex) => {
              const original = copia === 0 && columnItems[c].length > 0;
              pista.appendChild(this.crearFicha(item, c + '-' + copia + '-' + itemIndex, c, original, s));
            });
          }
          pista.style.transform = 'translate3d(0, ' + -this.offsets[c] + 'px, 0)';
          columna.appendChild(pista);
          fragmento.appendChild(columna);
          this.tracks.push(pista);
        });

        this.plano.textContent = '';
        this.plano.appendChild(fragmento);
        this.aplicarPlano(this.pointerDamped.x, this.pointerDamped.y);
        this.arrancar();
      }

      crearFicha(item, id, columna, original, s) {
        const conEnlace = !!item.enlace;
        const ficha = document.createElement(conEnlace ? 'a' : 'div');
        ficha.className = 'muro-deriva__ficha';
        ficha.dataset.ficha = id;
        ficha.dataset.col = String(columna);
        if (original) ficha.dataset.bloque = item.bloque;
        if (conEnlace) {
          ficha.href = item.enlace;
          if (item.nuevaPestana) {
            ficha.target = '_blank';
            ficha.rel = 'noopener noreferrer';
          }
          if (original) {
            ficha.setAttribute('aria-label', item.titulo || item.alt || 'Ver');
          } else {
            ficha.tabIndex = -1;
            ficha.setAttribute('aria-hidden', 'true');
          }
        } else if (!original) {
          ficha.setAttribute('aria-hidden', 'true');
        }

        const interior = document.createElement('span');
        interior.className = 'muro-deriva__interior';
        const img = document.createElement('img');
        img.className = 'muro-deriva__foto';
        img.src = item.src;
        if (item.srcset) {
          img.srcset = item.srcset;
          img.sizes = s.sizes;
        }
        img.width = item.ancho;
        img.height = item.alto;
        img.alt = original && !conEnlace ? item.alt : '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.draggable = false;
        img.addEventListener('error', () => {
          img.style.visibility = 'hidden';
        });
        const velo = document.createElement('span');
        velo.className = 'muro-deriva__velo';
        velo.setAttribute('aria-hidden', 'true');
        interior.appendChild(img);
        interior.appendChild(velo);
        if (s.mostrarNombre && item.titulo) {
          const nombre = document.createElement('span');
          nombre.className = 'muro-deriva__nombre';
          nombre.setAttribute('aria-hidden', 'true');
          nombre.textContent = item.titulo;
          interior.appendChild(nombre);
        }
        ficha.appendChild(interior);
        return ficha;
      }

      aplicarPlano(px, py) {
        const s = this.s;
        if (!s) return;
        this.plano.style.transform =
          'translate(-50%, -50%) scale(' + s.scale + ') ' +
          'rotateX(' + (s.tilt + py) + 'deg) rotateY(' + (s.turn + px) + 'deg) rotateZ(' + s.roll + 'deg) ' +
          'translateZ(' + -s.depth + 'px)';
      }

      arrancar() {
        if (this.raf || !this.visible || document.hidden || !this.isConnected) return;
        this.lastTs = null;
        this.raf = requestAnimationFrame((ts) => this.animar(ts));
      }

      parar() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.lastTs = null;
      }

      animar(ts) {
        this.raf = 0;
        const s = this.s;
        if (this.lastTs === null) this.lastTs = ts;
        const dt = Math.min(0.05, Math.max(0, ts - this.lastTs) / 1000);
        this.lastTs = ts;

        const maxTilt = s.parallax * 8;
        const targetX = this.pointer.x * maxTilt;
        const targetY = -this.pointer.y * maxTilt;
        const damp = 1 - Math.exp(-dt / 0.12);
        this.pointerDamped.x += (targetX - this.pointerDamped.x) * damp;
        this.pointerDamped.y += (targetY - this.pointerDamped.y) * damp;
        this.aplicarPlano(this.pointerDamped.x, this.pointerDamped.y);

        let seMueve =
          Math.abs(targetX - this.pointerDamped.x) > 0.001 || Math.abs(targetY - this.pointerDamped.y) > 0.001;

        if (!this.reducido) {
          for (let c = 0; c < this.tracks.length; c++) {
            const meta = this.columnMeta[c];
            if (!meta) continue;
            const paused = this.wallHovered && s.pauseOnHover;
            const factor = paused || this.hoveredCol === c ? 0 : 1;
            const target = this.baseVelocities[c] * factor;
            const ease = 1 - Math.exp(-dt / (target === 0 ? 0.16 : 0.28));
            this.velocities[c] += (target - this.velocities[c]) * ease;
            if (target === 0 && Math.abs(this.velocities[c]) < 0.5) this.velocities[c] = 0;
            let next = (this.offsets[c] || 0) + this.velocities[c] * dt;
            next = ((next % meta.copyHeight) + meta.copyHeight) % meta.copyHeight;
            this.offsets[c] = next;
            this.tracks[c].style.transform = 'translate3d(0, ' + -next + 'px, 0)';
            if (target !== 0 || Math.abs(this.velocities[c]) > 0.01) seMueve = true;
          }
        }

        if (seMueve && this.visible && !document.hidden) {
          this.raf = requestAnimationFrame((t) => this.animar(t));
        }
      }

      moverPuntero(evento) {
        const rect = this.muro.getBoundingClientRect();
        if (this.s.parallax > 0 && !this.reducido && evento.pointerType === 'mouse') {
          this.pointer = {
            x: (evento.clientX - rect.left) / rect.width - 0.5,
            y: (evento.clientY - rect.top) / rect.height - 0.5
          };
        }
        const hit = document.elementFromPoint(evento.clientX, evento.clientY);
        const ficha = hit && hit.closest ? hit.closest('[data-ficha]') : null;
        if (ficha && this.plano.contains(ficha)) this.activar(ficha);
        this.arrancar();
      }

      activar(ficha) {
        if (ficha === this.activa) return;
        if (this.activa) this.activa.classList.remove('esta-activa');
        this.activa = ficha;
        ficha.classList.add('esta-activa');
        this.hoveredCol = Number(ficha.dataset.col);
        this.arrancar();
      }

      soltar() {
        if (this.activa) this.activa.classList.remove('esta-activa');
        this.activa = null;
        this.hoveredCol = -1;
        this.arrancar();
      }
    }

    customElements.define('muro-deriva', MuroDeriva);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brumacoleccionMASVENDIDO"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bruma-coleccion')) return;

    const PARTES = ['[data-resultados]', '[data-contador]', '[data-activos]', '[data-panel-cuerpo]', '[data-panel-cuenta]', '[data-panel-aplicar]', '[data-numero-filtros]'];

    class BrumaColeccion extends HTMLElement {
      connectedCallback() {
        this.seccion = this.dataset.seccion;
        this.base = this.dataset.url || window.location.pathname;
        this.temporizador = 0;
        this.controlador = null;
        this.desbordePrevio = '';
        this.alClic = this.alClic.bind(this);
        this.alCambiar = this.alCambiar.bind(this);
        this.alEscribir = this.alEscribir.bind(this);
        this.alEnviar = this.alEnviar.bind(this);
        this.alVolver = this.alVolver.bind(this);
        this.alCancelar = this.alCancelar.bind(this);
        this.addEventListener('click', this.alClic);
        this.addEventListener('change', this.alCambiar);
        this.addEventListener('input', this.alEscribir);
        this.addEventListener('submit', this.alEnviar);
        window.addEventListener('popstate', this.alVolver);
        this.panel = this.querySelector('[data-panel]');
        if (this.panel) this.panel.addEventListener('cancel', this.alCancelar);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.alClic);
        this.removeEventListener('change', this.alCambiar);
        this.removeEventListener('input', this.alEscribir);
        this.removeEventListener('submit', this.alEnviar);
        window.removeEventListener('popstate', this.alVolver);
        if (this.panel) this.panel.removeEventListener('cancel', this.alCancelar);
        clearTimeout(this.temporizador);
        if (this.controlador) this.controlador.abort();
        if (this.panel && this.panel.open) document.documentElement.style.overflow = this.desbordePrevio;
      }

      get formulario() {
        return this.querySelector('[data-formulario]');
      }

      abrir() {
        if (!this.panel || this.panel.open) return;
        clearTimeout(this.cierre);
        if (typeof this.panel.showModal === 'function') {
          this.panel.showModal();
        } else {
          this.panel.setAttribute('open', '');
        }
        this.desbordePrevio = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(() => requestAnimationFrame(() => this.panel.classList.add('esta-abierto')));
        const cerrar = this.panel.querySelector('[data-cerrar-filtros]');
        if (cerrar) cerrar.focus({ preventScroll: true });
      }

      cerrar() {
        if (!this.panel || !this.panel.open) return;
        this.panel.classList.remove('esta-abierto');
        const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        clearTimeout(this.cierre);
        this.cierre = setTimeout(() => {
          if (typeof this.panel.close === 'function') {
            this.panel.close();
          } else {
            this.panel.removeAttribute('open');
          }
          document.documentElement.style.overflow = this.desbordePrevio;
          const boton = this.querySelector('[data-abrir-filtros]');
          if (boton) boton.focus({ preventScroll: true });
        }, reducido ? 0 : 380);
      }

      alCancelar(evento) {
        evento.preventDefault();
        this.cerrar();
      }

      alClic(evento) {
        if (evento.target === this.panel) {
          this.cerrar();
          return;
        }
        if (evento.target.closest('[data-abrir-filtros]')) {
          this.abrir();
          return;
        }
        if (evento.target.closest('[data-cerrar-filtros]')) {
          this.cerrar();
          return;
        }
        const enlace = evento.target.closest('a[data-enlace-ajax]');
        if (!enlace || evento.metaKey || evento.ctrlKey || evento.shiftKey) return;
        evento.preventDefault();
        const url = new URL(enlace.href, window.location.origin);
        this.cargar(this.limpiar(url.searchParams), { desplazar: enlace.hasAttribute('data-paginacion') });
      }

      alCambiar(evento) {
        const campo = evento.target;
        if (!campo.closest('[data-formulario]')) return;
        if (campo.matches('[data-precio]')) {
          this.programar(0);
        } else if (campo.type === 'checkbox' || campo.type === 'radio') {
          this.programar(200);
        }
      }

      alEscribir(evento) {
        if (evento.target.matches('[data-precio]')) this.programar(800);
      }

      alEnviar(evento) {
        if (!evento.target.matches('[data-formulario]')) return;
        evento.preventDefault();
        clearTimeout(this.temporizador);
        this.cargar(this.parametros()).then(() => this.cerrar());
      }

      programar(espera) {
        clearTimeout(this.temporizador);
        this.temporizador = setTimeout(() => this.cargar(this.parametros()), espera);
      }

      limpiar(busqueda) {
        const salida = new URLSearchParams(busqueda);
        salida.delete('section_id');
        return salida.toString();
      }

      parametros() {
        const formulario = this.formulario;
        if (!formulario) return '';
        const datos = new FormData(formulario);
        const salida = new URLSearchParams();
        datos.forEach((valor, clave) => {
          if (String(valor).trim() !== '') salida.append(clave, valor);
        });
        return salida.toString();
      }

      cargar(consulta, opciones = {}) {
        if (this.controlador) this.controlador.abort();
        this.controlador = new AbortController();
        const destino = this.base + (consulta ? '?' + consulta : '');
        const peticion = destino + (consulta ? '&' : '?') + 'section_id=' + encodeURIComponent(this.seccion);
        this.setAttribute('aria-busy', 'true');
        return fetch(peticion, { signal: this.controlador.signal, credentials: 'same-origin' })
          .then((respuesta) => {
            if (!respuesta.ok) throw new Error('HTTP ' + respuesta.status);
            return respuesta.text();
          })
          .then((html) => {
            const documento = new DOMParser().parseFromString(html, 'text/html');
            const nuevo = documento.querySelector('bruma-coleccion[data-seccion="' + this.seccion + '"]') || documento.querySelector('bruma-coleccion');
            if (!nuevo) throw new Error('Sin contenido');
            this.reemplazar(nuevo);
            if (opciones.historia !== false) {
              window.history.pushState({ brumaColeccion: true }, '', destino);
            }
            if (opciones.desplazar) {
              const arriba = this.getBoundingClientRect().top + window.scrollY - 80;
              window.scrollTo({ top: Math.max(0, arriba), behavior: 'smooth' });
            }
            this.removeAttribute('aria-busy');
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            window.location.href = destino;
          });
      }

      reemplazar(nuevo) {
        const cuerpo = this.querySelector('[data-panel-cuerpo]');
        const abiertos = {};
        let desplazamiento = 0;
        let enfocado = null;
        let cursor = null;
        if (cuerpo) {
          desplazamiento = cuerpo.scrollTop;
          cuerpo.querySelectorAll('details[data-grupo]').forEach((grupo) => {
            abiertos[grupo.dataset.grupo] = grupo.open;
          });
          const activo = document.activeElement;
          if (activo && cuerpo.contains(activo) && activo.id) {
            enfocado = activo.id;
            try {
              cursor = activo.selectionStart;
            } catch (error) {
              cursor = null;
            }
          }
        }
        PARTES.forEach((selector) => {
          const viejo = this.querySelector(selector);
          const fresco = nuevo.querySelector(selector);
          if (viejo && fresco) viejo.innerHTML = fresco.innerHTML;
        });
        const cuerpoNuevo = this.querySelector('[data-panel-cuerpo]');
        if (cuerpoNuevo) {
          cuerpoNuevo.querySelectorAll('details[data-grupo]').forEach((grupo) => {
            if (grupo.dataset.grupo in abiertos) grupo.open = abiertos[grupo.dataset.grupo];
          });
          cuerpoNuevo.scrollTop = desplazamiento;
          if (enfocado) {
            const campo = document.getElementById(enfocado);
            if (campo) {
              campo.focus({ preventScroll: true });
              if (cursor !== null && typeof campo.setSelectionRange === 'function') {
                try {
                  campo.setSelectionRange(cursor, cursor);
                } catch (error) {
                  cursor = null;
                }
              }
            }
          }
        }
      }

      alVolver() {
        if (window.location.pathname !== this.base) return;
        this.cargar(this.limpiar(window.location.search), { historia: false });
      }
    }

    customElements.define('bruma-coleccion', BrumaColeccion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-ugc"] && !Shopify.designMode) return;
  try {
    
  class CarruselUgc extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.tarjetas = Array.from(this.querySelectorAll('[data-tarjeta]'));
      this.modal = this.querySelector('[data-modal]');
      this.modalVideo = this.querySelector('[data-modal-video]');
      this.indice = 0;

      if (!this.pista || this.tarjetas.length === 0) return;

      this.anterior = this.querySelector('[data-anterior]');
      this.siguiente = this.querySelector('[data-siguiente]');

      this.tarjetas.forEach((tarjeta) => {
        tarjeta.addEventListener('click', () => {
          this.abrir(parseInt(tarjeta.dataset.indice, 10) || 0);
        });
      });

      if (this.anterior) {
        this.anterior.addEventListener('click', () => this.desplazar(-1));
      }
      if (this.siguiente) {
        this.siguiente.addEventListener('click', () => this.desplazar(1));
      }

      this.pista.addEventListener('scroll', () => this.actualizarFlechas(), { passive: true });
      window.addEventListener('resize', () => this.actualizarFlechas());
      window.addEventListener('load', () => this.actualizarFlechas());
      this.actualizarFlechas();

      if (this.dataset.reproducirEnVista === 'true') this.observarVideos();
      this.prepararModal();
    }

    paso() {
      const primera = this.tarjetas[0];
      if (!primera) return 220;
      const estilo = window.getComputedStyle(this.pista);
      const hueco = parseFloat(estilo.columnGap || estilo.gap) || 0;
      return primera.getBoundingClientRect().width + hueco;
    }

    desplazar(direccion) {
      this.pista.scrollBy({ left: this.paso() * direccion * 2, behavior: 'smooth' });
    }

    actualizarFlechas() {
      if (!this.anterior || !this.siguiente) return;
      const estilo = window.getComputedStyle(this.pista);
      const relleno = parseFloat(estilo.paddingLeft) || 0;
      const maximo = this.pista.scrollWidth - this.pista.clientWidth;
      this.anterior.toggleAttribute('disabled', this.pista.scrollLeft <= relleno + 2);
      this.siguiente.toggleAttribute('disabled', this.pista.scrollLeft >= maximo - 2);
    }

    observarVideos() {
      const observador = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((entrada) => {
            const video = entrada.target.querySelector('[data-video]');
            if (!video) return;
            if (entrada.isIntersecting) {
              if (video.preload === 'none') video.preload = 'metadata';
              const promesa = video.play();
              if (promesa && promesa.catch) promesa.catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );

      this.tarjetas.forEach((tarjeta) => observador.observe(tarjeta));
    }

    prepararModal() {
      if (!this.modal || typeof this.modal.showModal !== 'function') return;

      const cerrar = this.querySelector('[data-cerrar]');
      const anterior = this.querySelector('[data-modal-anterior]');
      const siguiente = this.querySelector('[data-modal-siguiente]');

      if (cerrar) cerrar.addEventListener('click', () => this.modal.close());
      if (anterior) anterior.addEventListener('click', () => this.ir(this.indice - 1));
      if (siguiente) siguiente.addEventListener('click', () => this.ir(this.indice + 1));

      this.modal.addEventListener('click', (evento) => {
        if (evento.target === this.modal) this.modal.close();
      });

      this.modal.addEventListener('close', () => {
        if (this.modalVideo) {
          this.modalVideo.pause();
          this.modalVideo.removeAttribute('src');
          this.modalVideo.load();
        }
      });

      this.modal.addEventListener('keydown', (evento) => {
        if (evento.key === 'ArrowRight') this.ir(this.indice + 1);
        if (evento.key === 'ArrowLeft') this.ir(this.indice - 1);
      });
    }

    abrir(indice) {
      if (!this.modal || typeof this.modal.showModal !== 'function') return;
      this.ir(indice);
      if (!this.modal.open) this.modal.showModal();
    }

    ir(indice) {
      if (indice < 0 || indice >= this.tarjetas.length) return;
      this.indice = indice;

      const tarjeta = this.tarjetas[indice];
      const fuente = tarjeta.dataset.fuente;

      if (this.modalVideo && fuente) {
        this.modalVideo.src = fuente;
        const promesa = this.modalVideo.play();
        if (promesa && promesa.catch) promesa.catch(() => {});
      }

      const anterior = this.querySelector('[data-modal-anterior]');
      const siguiente = this.querySelector('[data-modal-siguiente]');
      if (anterior) anterior.hidden = indice === 0;
      if (siguiente) siguiente.hidden = indice === this.tarjetas.length - 1;

      const enlace = this.querySelector('[data-modal-producto]');
      if (!enlace) return;

      if (tarjeta.dataset.productoUrl) {
        enlace.hidden = false;
        enlace.href = tarjeta.dataset.productoUrl;
        const imagen = enlace.querySelector('[data-modal-producto-imagen]');
        const titulo = enlace.querySelector('[data-modal-producto-titulo]');
        const precio = enlace.querySelector('[data-modal-producto-precio]');
        if (imagen) imagen.src = tarjeta.dataset.productoImagen || '';
        if (titulo) titulo.textContent = tarjeta.dataset.productoTitulo || '';
        if (precio) precio.textContent = tarjeta.dataset.productoPrecio || '';
      } else {
        enlace.hidden = true;
      }
    }
  }

  if (!customElements.get('carrusel-ugc')) {
    customElements.define('carrusel-ugc', CarruselUgc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-videos"] && !Shopify.designMode) return;
  try {
    
  class CarruselVideos extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.tarjetas = Array.from(this.querySelectorAll('[data-tarjeta]'));
      if (!this.pista) return;

      this.videos = Array.from(this.querySelectorAll('video'));
      this.videos.forEach((video) => {
        video.setAttribute('playsinline', '');
        video.muted = true;
        video.loop = true;
      });

      this.prepararFlechas();
      this.prepararSonido();
      this.prepararExternos();
      this.prepararVisibilidad();
    }

    disconnectedCallback() {
      if (this.observador) this.observador.disconnect();
      if (this.medidor) this.medidor.disconnect();
      if (this.pista && this.alDesplazar) this.pista.removeEventListener('scroll', this.alDesplazar);
      if (this.alDesplazar) window.removeEventListener('load', this.alDesplazar);
    }

    prepararFlechas() {
      const anterior = this.querySelector('[data-anterior]');
      const siguiente = this.querySelector('[data-siguiente]');
      if (!anterior || !siguiente) return;

      const paso = () => {
        const tarjeta = this.tarjetas[0];
        if (!tarjeta) return this.pista.clientWidth;
        const estilo = window.getComputedStyle(this.pista);
        return tarjeta.getBoundingClientRect().width + parseFloat(estilo.columnGap || estilo.gap || 0);
      };

      anterior.addEventListener('click', () => this.pista.scrollBy({ left: -paso(), behavior: 'smooth' }));
      siguiente.addEventListener('click', () => this.pista.scrollBy({ left: paso(), behavior: 'smooth' }));

      this.alDesplazar = () => {
        const relleno = parseFloat(window.getComputedStyle(this.pista).paddingLeft) || 0;
        const max = this.pista.scrollWidth - this.pista.clientWidth - 2;
        anterior.toggleAttribute('disabled', this.pista.scrollLeft <= relleno + 2);
        siguiente.toggleAttribute('disabled', this.pista.scrollLeft >= max);
      };

      this.pista.addEventListener('scroll', this.alDesplazar, { passive: true });

      requestAnimationFrame(() => this.alDesplazar());
      window.addEventListener('load', this.alDesplazar);

      if ('ResizeObserver' in window) {
        this.medidor = new ResizeObserver(() => this.alDesplazar());
        this.medidor.observe(this.pista);
      }
    }

    prepararSonido() {
      this.querySelectorAll('[data-sonido]').forEach((boton) => {
        boton.addEventListener('click', () => {
          const tarjeta = boton.closest('[data-tarjeta]');
          const video = tarjeta.querySelector('video');
          if (!video) return;

          const activar = video.muted;

          this.videos.forEach((otro) => {
            otro.muted = true;
            const suTarjeta = otro.closest('[data-tarjeta]');
            if (suTarjeta) suTarjeta.classList.remove('tiene-sonido');
          });

          if (activar) {
            video.muted = false;
            tarjeta.classList.add('tiene-sonido');
            const reproduccion = video.play();
            if (reproduccion && reproduccion.catch) reproduccion.catch(() => {});
          }
        });
      });
    }

    prepararExternos() {
      this.querySelectorAll('[data-externo]').forEach((contenedor) => {
        contenedor.addEventListener('click', () => {
          if (contenedor.querySelector('iframe')) return;
          const id = contenedor.dataset.externo;
          const tipo = contenedor.dataset.tipo;
          const url =
            tipo === 'vimeo'
              ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
              : 'https://www.youtube.com/embed/' + id + '?autoplay=1';
          const marco = document.createElement('iframe');
          marco.src = url;
          marco.allow = 'autoplay; encrypted-media; picture-in-picture';
          marco.setAttribute('allowfullscreen', '');
          marco.setAttribute('title', 'Vídeo');
          contenedor.appendChild(marco);
        });
      });
    }

    prepararVisibilidad() {
      if (this.dataset.reproduccion === 'false' || !('IntersectionObserver' in window)) return;

      this.observador = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((entrada) => {
            const video = entrada.target;
            if (entrada.isIntersecting) {
              const reproduccion = video.play();
              if (reproduccion && reproduccion.catch) reproduccion.catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.35 }
      );

      this.videos.forEach((video) => this.observador.observe(video));
    }
  }

  if (!customElements.get('carrusel-videos')) {
    customElements.define('carrusel-videos', CarruselVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccionesbruma"] && !Shopify.designMode) return;
  try {
    
  class ColeccionesDestacadas extends HTMLElement {
    connectedCallback() {
      this.pestanas = Array.from(this.querySelectorAll('[data-pestana]'));
      this.listas = Array.from(this.querySelectorAll('[data-lista]'));
      this.enlaces = Array.from(this.querySelectorAll('[data-ver-todo]'));
      this.flechas = Array.from(this.querySelectorAll('[data-ir]'));
      this.indice = 0;

      this.pestanas.forEach((pestana) => {
        pestana.addEventListener('click', () => this.abrir(Number(pestana.dataset.indice)));
      });

      this.flechas.forEach((flecha) => {
        flecha.addEventListener('click', () => this.desplazar(Number(flecha.dataset.ir)));
      });

      this.alDesplazar = () => this.repasarFlechas();
      this.listas.forEach((lista) => lista.addEventListener('scroll', this.alDesplazar, { passive: true }));

      this.alRedimensionar = () => this.repasarFlechas();
      window.addEventListener('resize', this.alRedimensionar);

      this.repasarFlechas();
    }

    disconnectedCallback() {
      this.listas.forEach((lista) => lista.removeEventListener('scroll', this.alDesplazar));
      window.removeEventListener('resize', this.alRedimensionar);
    }

    get listaActiva() {
      return this.listas[this.indice] || null;
    }

    abrir(indice) {
      if (indice === this.indice) return;
      this.indice = indice;

      this.pestanas.forEach((pestana, i) => {
        const activa = i === indice;
        pestana.classList.toggle('esta-activa', activa);
        pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
      });

      this.listas.forEach((lista, i) => lista.classList.toggle('esta-activa', i === indice));
      this.enlaces.forEach((enlace, i) => enlace.classList.toggle('esta-activa', i === indice));

      const lista = this.listaActiva;
      if (lista) lista.scrollTo({ left: 0, behavior: 'auto' });
      this.repasarFlechas();
    }

    paso(lista) {
      const tarjeta = lista.querySelector('.colecciones__tarjeta');
      if (!tarjeta) return lista.clientWidth;
      const estilo = window.getComputedStyle(lista);
      const hueco = parseFloat(estilo.columnGap || estilo.gap) || 0;
      return tarjeta.getBoundingClientRect().width + hueco;
    }

    desplazar(sentido) {
      const lista = this.listaActiva;
      if (!lista) return;
      lista.scrollBy({ left: this.paso(lista) * sentido, behavior: 'smooth' });
    }

    repasarFlechas() {
      const lista = this.listaActiva;
      if (!lista || !this.flechas.length) return;
      const margen = 4;
      const tope = lista.scrollWidth - lista.clientWidth;
      this.flechas.forEach((flecha) => {
        const sentido = Number(flecha.dataset.ir);
        const bloqueada = sentido < 0 ? lista.scrollLeft <= margen : lista.scrollLeft >= tope - margen;
        if (bloqueada) {
          flecha.setAttribute('disabled', 'disabled');
        } else {
          flecha.removeAttribute('disabled');
        }
      });
    }
  }

  if (!customElements.get('colecciones-destacadas')) {
    customElements.define('colecciones-destacadas', ColeccionesDestacadas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compra-por-necesidad"] && !Shopify.designMode) return;
  try {
    
  class CompraPorNecesidad extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.anterior = this.querySelector('[data-anterior]');
      this.siguiente = this.querySelector('[data-siguiente]');
      if (!this.pista || !this.anterior || !this.siguiente) return;

      this.anterior.addEventListener('click', () => this.desplazar(-1));
      this.siguiente.addEventListener('click', () => this.desplazar(1));

      this.actualizar = () => {
        const relleno = parseFloat(window.getComputedStyle(this.pista).paddingLeft) || 0;
        const maximo = this.pista.scrollWidth - this.pista.clientWidth - 2;
        this.anterior.toggleAttribute('disabled', this.pista.scrollLeft <= relleno + 2);
        this.siguiente.toggleAttribute('disabled', this.pista.scrollLeft >= maximo);
      };

      this.pista.addEventListener('scroll', this.actualizar, { passive: true });
      window.addEventListener('load', this.actualizar);
      requestAnimationFrame(() => this.actualizar());

      if ('ResizeObserver' in window) {
        this.medidor = new ResizeObserver(() => this.actualizar());
        this.medidor.observe(this.pista);
      }
    }

    disconnectedCallback() {
      if (this.medidor) this.medidor.disconnect();
      if (this.actualizar) {
        this.pista.removeEventListener('scroll', this.actualizar);
        window.removeEventListener('load', this.actualizar);
      }
    }

    desplazar(sentido) {
      const tarjeta = this.querySelector('.necesidad__tarjeta');
      const estilo = window.getComputedStyle(this.pista);
      const separacion = parseFloat(estilo.columnGap || estilo.gap) || 0;
      const paso = tarjeta ? tarjeta.getBoundingClientRect().width + separacion : this.pista.clientWidth;
      this.pista.scrollBy({ left: paso * sentido, behavior: 'smooth' });
    }
  }

  if (!customElements.get('compra-por-necesidad')) {
    customElements.define('compra-por-necesidad', CompraPorNecesidad);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
